
 <div *ngIf="showMessage" class="status-modal-box  transition delay scale-1" [ngClass]="{'show-modal-box': showMessage, 'hide-modal-box': !showMessage}">
	<div class="status-card transition w-100per position-fixed top-10 bg-white-color modal-box-card d-flex flex-y-center w-100per justify-space-between p-10-20 bdr-radius-10 mb-10">
	  <div class="d-flex flex-y-center">
		<img
		  src="{{commonService.aws_asset_url}}/_assets/icons/light-mode/{{alertType=='error-box' ? 'red-circle-error.svg' :
			alertType=='success-box' ? 'green-sucess.svg' : 
			alertType=='warning-box' ? 'red-warning.svg' : 
			null }}"
		  width="20px"
		  height="20px"
		  alt="alert-logo"
		  class="mr-20"
		/>
		<div class="ml-10">
		  <h4 class="m-0 text-size-18 text-bold"
		  [ngClass]="{'text-red': alertType=='error-box', 'text-orange-color': alertType=='warning-box', 'text-green' :  alertType=='success-box' }">
			{{alertType === "error-box"
			? "Error"
			: alertType === "warning-box"
			? "Warning"
			: alertType === "success-box"
			? "Success"
			: null}}
		  </h4>
		  <small className="text-dark-grey-color text-size-12 mt-5 mb-0">
		   {{message}}
		  </small>
		</div>
	  </div>
	  <img
		src="{{commonService.aws_asset_url}}/_assets/icons/red-close.svg"
		alt="close-btn"
		(click)="hideError()"
		className=" close-btn"
	  />
	</div>
  </div>
  
<ng-keyboard-shortcuts [shortcuts]="shortcuts"></ng-keyboard-shortcuts>


<button type="button" hidden #openSuccessModal data-toggle="modal" data-target="#successModal"></button>

			<!-- Modal -->
			<div id="successModal" class="modal fade" role="dialog" data-backdrop="false">
				<div class="modal-dialog transaction-creation-modal">
					<!-- Modal content-->
					<div class="modal-content">
						<div class="modal-header">
							<span class="messageFont">
								<span>
									{{message}} 
								</span>
									<a *ngIf="invoice_number != ''" 
										href="javascript:void(0)"	
										(click)="openVoucher(invoice_number)">
										{{invoice_number}}
									</a>
									<a *ngIf="invoice_number != ''" [title]="copyELementTitle" (click)="copytext(invoice_number)" >

										<i class="fa fa-copy cursor-pointer"></i>
									</a>
								</span>
								<button type="button" class="close" (click)="closeSuccesModal()">&times;</button>
							</div>
						<div class="modal-body">
							
							<p>Do you want to create new invoice or  view newly created Invoice ?</p>
						</div>
						<div class="modal-footer justify-content-center">
							<button 
								tabIndex="1" 
								tabindex="1"
								type="button" 
								class="btn btn-primary bg-blue" 
								(click)="viewInvoice(invoice_number)">
								View
							</button>
							<button 
								tabIndex="2" 
								tabindex="2"
								type="button" 
								class="btn btn-primary btn-grey" 
								(click)="openVoucher(invoice_number)">
								Print
							</button>
							<button 
								tabIndex="3" 
								tabindex="3"
								type="button" 
								class="btn btn-primary bg-green"  
								(click)="closeSuccesModal()">
								Create New
							</button>
						</div>
					</div>

				</div>
			</div>



<form [formGroup]="miscInvoiceService.invoiceForm" [ngClass]="{'d-none': !newInvoice}" class="ledger-container ">
	<div class="row tab-nav pl-0 pr-0">
		<!-- <div class="col-sm-4 pl-0">
			<ul class="list-inline list-unstyled p-0 m-0">
				<li class="active page-title text-uppercase cursor"> View Client</li>
			</ul>
		</div> -->
		<div class="col-sm-12 ">
		  <ul class="page-nav d-flex align-item-center list-inline list-unstyled p-0 m-0">
			<li class="text-grey text-capitalize cursor text-primary transition">Invoice</li>
			<li><img src="{{commonService.aws_asset_url}}/_assets/icons/light-mode/angle-right.svg" alt=""></li>
			<li class="text-grey text-capitalize cursor  hover-text-primary transition"> Misc</li>
			<li><img src="{{commonService.aws_asset_url}}/_assets/icons/light-mode/angle-right.svg" alt=""></li>
			<li class="text-grey text-capitalize cursor  hover-text-primary transition"> {{transactionType}}</li>
		  </ul>
	  </div>
	</div>
<div class="pl-15 pr-15 custom-form form-container w-100 mb-4">
	<div class=" mb-0 mt-2 mb-fix miscInvoiceServiceContainer">
		<div class="invoice-container invoice-table">
			<div>
				<table class="table table-hovered table-bordered top-miscellaneous-bar w-100">
					<thead>
						<tr>
							<th style="width: 70px;">Acc. Type</th>
							<th>Account</th>
							<th style="width: 8%;">Inv Type</th>
							<th style="width: 12%;" *ngIf="miscInvoiceService.invoiceForm.value.sub_invoice_type == 'tour'">Tour Account</th>
							<th style="width: 100px;">Sub Ledger Type</th>
							<th>Sub-ledger</th>
							<th style="width: 100px;">Invoice Date</th>
							<th style="width: 100px;" *ngIf="paymentTypeColumn == 'true'">Payment Type</th>
							<th style="width: 100px;" *ngIf="!isTenantIndian">Purchase currency</th>
							<th style="width: 40px;" *ngIf="!isTenantIndian">Rate({{currencyCode}}-{{miscInvoiceService.invoiceForm.value.purchase_currency}})</th>
							<th style="width: 150px;" *ngIf="miscInvoiceService.invoiceForm.value.reference_invoice_number">Reference</th>
							<th style="width: 150px;">Invoice Number</th>
							<th style="width: 150px;">Employee</th>
							<th *ngIf="invoiceType=='visa-invoice'">Visa Type</th>
							<th style="width: 85px;" *ngIf="invoiceType=='visa-invoice'">setvice Started</th>
							<th style="width: 85px;" *ngIf="invoiceType=='visa-invoice'">setvice Ended</th>
							<th style="width: 50px;" *ngIf="invoiceType=='visa-invoice'">Total Days</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>
								<select class="inner-select" tabIndex="4" tabindex="4"
									formControlName="client_account_type" (change)="resetSelection('client_code')">
									<option value="">Select</option>
									<option value="client">Client</option>
									<option value="airline">Airline</option>
									<option value="supplier">Supplier</option>
									<!-- <option value="employee">Employee</option> -->
									<option value="general">General</option>
								</select>
							</td>
							<!-- client -->
							<td tabIndex="5" tabindex="5" (focus)="focusClientAc()"
								style="text-align: left; width: 200px;">
								<ng-autocomplete [data]="bookingClientArr" #clientAC formControlName="client_code_name"
									[searchKeyword]="keyword" (selected)="selectAccount($event,'client_code', null)"
									(inputChanged)='clientSearch($event,true)' (inputFocused)='onFocused($event)'
									(inputCleared)="selectAccount($event,'client_code', null)"
									[itemTemplate]="itemTemplate" [notFoundTemplate]="notFoundTemplate">
								</ng-autocomplete>

								<ng-template #itemTemplate let-item>
									<a innerHTML='<span class="colr-1">{{item?.name}}
										({{item?.account_code}})</span>'>
									</a>
								</ng-template>

								<ng-template #notFoundTemplate let-notFound>
									<div [innerHTML]="notFound"></div>
								</ng-template>

							</td>

							<td>
								<select class="inner-select"
									formControlName="sub_invoice_type" >
									<option value="normal">Normal</option>
									<option value="tour">Tour</option>
								</select>
							</td>
							<!-- tour -->
							<td *ngIf="miscInvoiceService.invoiceForm.value.sub_invoice_type == 'tour'"  (focus)="focusTourAc()"
								style="text-align: left; width: 200px;">
								<ng-autocomplete [data]="bookingTourArr" #tourAC formControlName="tour_code_name"
									[searchKeyword]="keyword" (selected)="selectAccount($event,'tour_code', null)"
									(inputChanged)='tourSearch($event,true)' (inputFocused)='onFocused($event)'
									(inputCleared)="selectAccount($event,'tour_code', null)"
									[itemTemplate]="itemTemplate" 
									>
									<!-- [ngClass]="{'validate-ng-error': (miscInvoiceService.invoiceForm.controls.client_code_name.invalid && miscInvoiceService.invoiceForm.controls.client_code_name.touched) || 
									(!miscInvoiceService.invoiceForm.controls.client_code_name.valid && sectorService.submitted)}" -->
								</ng-autocomplete>

								<ng-template #itemTemplate let-item>
									<a
									    innerHTML='<span class="colr-1 selected-ng">{{item.name}}<span *ngIf="item.account_code">({{item.account_code}})<span></span><br />'>
								    </a>
								</ng-template>

							</td>

							<td>
								<select class="inner-select" tabIndex="6" tabindex="6" formControlName="subledger_type">
									<option value="">Select</option>
									<option value="client">Client</option>
									<option value="airline">Airline</option>
									<option value="supplier">Supplier</option>
									<option value="employee">Employee</option>
									<option value="general">General</option>
								</select>
							</td>
							<td style="text-align: left;
							width: 135px;" tabIndex="7" tabindex="7" (focus)="focusSubledgerAc()">
								<ng-autocomplete [data]="miscInvoiceService.ledgerList" #subLedgerAC
									[searchKeyword]="keyword" (selected)="selectAccount($event,'subledger_code', null)"
									formControlName="subledger_code_name" (inputChanged)='ledgerSearch($event)'
									(inputFocused)='onFocused($event)' [itemTemplate]="itemTemplate"
									(inputCleared)="selectAccount($event,'subledger_code', null)"
									[notFoundTemplate]="notFoundTemplate">
								</ng-autocomplete>
	
	
								<ng-template #itemTemplate let-item>
									<a
										innerHTML='<span class="colr-1 selected-ng">{{item.name}}({{item.account_code}})</span><br />'>
									</a>
								</ng-template>
	
								<ng-template #notFoundTemplate let-notFound>
									<div [innerHTML]="notFound"></div>
								</ng-template>
	
							</td>
							
							<td>
								<ng-container *ngIf="isLocaleDateFormat">
                                    <input tabIndex="8" tabindex="8" style="min-width: max-content; padding: 0;"
									min="{{minDate}}" 
									max="{{maxDate}}"
									class="input-field" type="date" formControlName="invoice_date"
									(blur)="setServiceDate($event)"
									placeholder="MM/DD/YYYY" autocomplete="off" 
									[ngClass]="{'error-box': miscInvoiceService.invoiceForm.controls.invoice_date.dirty && !miscInvoiceService.invoiceForm.controls.invoice_date.valid}"/>
							</ng-container>
                                <ng-container *ngIf="!isLocaleDateFormat && miscInvoiceService.invoiceForm.controls.invoice_date">
                                    <app-date-time-input
                                    [formControl]="miscInvoiceService.invoiceForm.controls.invoice_date"
                                    (blur)="setServiceDate($event)"
                                    [dateFormat]="dateFormat"
                                    [minDate]="minDate"
                        			[maxDate]="maxDate"
                                    [fieldController]="miscInvoiceService.invoiceForm.controls.invoice_date"
									tIndex="8"
                                    class="new-date-input"
                                    classes="input-field" 
                                    styles="min-width: max-content; padding: 0;"
                                    [dynamicClasses]="{'error-box': !miscInvoiceService.invoiceForm.controls.invoice_date.valid}"
                                    ></app-date-time-input>
                                </ng-container>
								</td>
							<td *ngIf="paymentTypeColumn == 'true'">
								<select formControlName="paymentType" class="input-ui inv-date-input">
									<option value="">Select Payment Type</option>
									<option value="credit">Credit</option>
									<option value="cash">Cash</option>
								</select>
							</td>
							<td *ngIf="!isTenantIndian">
								<select id="flightType" tabIndex="9" tabindex="9" formControlName="purchase_currency"  class="input-ui inv-date-input" >
									<option value="">Select</option>
									<option value="AED">AED</option>
									<option value="CAD">CAD</option>
									<option value="USD">USD</option>
									<option value="INR">INR</option>
									<option value="EURO">EURO</option>
									<option value="POUND">POUND</option>
								</select>
							</td>
							<td *ngIf="!isTenantIndian">
								<input type="text" tabIndex="10" tabindex="10"  class="field-input text-center" name="" formControlName="purchase_currency_rate" />
							</td>
							<td>
								<ng-container  *ngIf="invoiceMode == 'save'; else invoiceNumber">-</ng-container>
								<ng-template #invoiceNumber>
									<span style="min-width: max-content; padding: 0;">{{miscInvoiceService.invoiceForm.value.invoice_number}}</span>
									<!-- <input  class="input-field" type="text" formControlName="invoice_number" disabled /> -->
								</ng-template>
							</td>

							


							<td tabIndex="{{isTenantIndian ? 9 : 11}}" tabindex="{{isTenantIndian ? 9 : 11}}" class="text-center" (focus)="focusEmployeeAc()">

								<ng-autocomplete [data]="employeeList" #employeeAC [searchKeyword]="keyword"
									formControlName="employee_name" (selected)="selectAccount($event,'employee', null)"
									(inputChanged)='employeeSearch($event)' (inputFocused)='onFocused($event)'
									[itemTemplate]="itemTemplate"
									[disabled]="true"
									[notFoundTemplate]="notFoundTemplate">
								</ng-autocomplete>
	
	
								<ng-template #itemTemplate let-item>
									<a
										innerHTML='<span class="colr-1 selected-ng">{{item.name}}({{item.account_code}})</span><br />'>
									</a>
								</ng-template>
	
								<ng-template #notFoundTemplate let-notFound>
									<div [innerHTML]="notFound"></div>
								</ng-template>
	
								<span class="text-danger"
									*ngIf="miscInvoiceService.invoiceForm.value.employee == ''">Please Enter
									Employee</span>
							</td>
							<td *ngIf="invoiceType=='visa-invoice'">
								<select class="inner-select" tabIndex="9" tabindex="9" *ngIf="isTenantIndian" 
									formControlName="type">
									<option value="">Select</option>
									<option value="normal" >NORMAL</option>
									<option value="outstation" >OUTSTATION</option>
									<option value="DEPENDENT" *ngIf="visaType=='true'" >DEPENDENT</option>
									<option value="VISIT" *ngIf="visaType=='true'">VISIT</option>
									<option value="EMPLOYMENT" *ngIf="visaType=='true'">EMPLOYMENT</option>
									<option value="EDUCATION" *ngIf="visaType=='true'">EDUCATION</option>
									<option value="Tourist" *ngIf="visaType=='true'">Tourist</option>
									<option value="Business" *ngIf="visaType=='true'">Business</option>
									<option value="Work" *ngIf="visaType=='true'">Work</option>
									<option value="Student" *ngIf="visaType=='true'">Student</option>
									<option value="Transit" *ngIf="visaType=='true'">Transit</option>
									<option value="Investor" *ngIf="visaType=='true'">Investor</option>
									<option value="Freelancer" *ngIf="visaType=='true'">Freelancer</option>
									<option value="Diplomatic" *ngIf="visaType=='true'">Diplomatic</option>
									<option value="Medical" *ngIf="visaType=='true'">Medical</option>
									<option value="Religious" *ngIf="visaType=='true'">Religious</option>
									<option value="Retirement" *ngIf="visaType=='true'">Retirement</option>
									<option value="Journalist" *ngIf="visaType=='true'">Journalist</option>
									<option value="Conference" *ngIf="visaType=='true'">Conference</option>
									<option value="e-Visa" *ngIf="visaType=='true'">e-Visa</option>
									<option value="Permanent Residence" *ngIf="visaType=='true'">Permanent Residence</option>
									<option value="Refugee/Asylum" *ngIf="visaType=='true'">Refugee/Asylum</option>
									<option value="Cultural Exchange" *ngIf="visaType=='true'">Cultural Exchange</option>
									<option value="Training" *ngIf="visaType=='true'">Training</option>
									<option value="Volunteer" *ngIf="visaType=='true'">Volunteer</option>
									<option value="Entrepreneur" *ngIf="visaType=='true'">Entrepreneur</option>
									<option value="Start-up" *ngIf="visaType=='true'">Start-up</option>
									<option value="Self-Employment" *ngIf="visaType=='true'">Self-Employment </option>
									<option value="Artist" *ngIf="visaType=='true'">Artist</option>
									<option value="Athlete/Sports" *ngIf="visaType=='true'">Athlete/Sports</option>
									<option value="Research" *ngIf="visaType=='true'">Research</option>
									<option value="Missionary" *ngIf="visaType=='true'">Missionary</option>
									<option value="Crew Member" *ngIf="visaType=='true'">Crew Member</option>
									<option value="Seafarer" *ngIf="visaType=='true'">Seafarer</option>
									<option value="Pilgrimage" *ngIf="visaType=='true'">Pilgrimage</option>
									<option value="Marriage" *ngIf="visaType=='true'">Marriage</option>
									<option value="Adoption" *ngIf="visaType=='true'">Adoption</option>
									<option value="Working Holiday" *ngIf="visaType=='true'">Working Holiday</option>
									<option value="Exchange Visitor" *ngIf="visaType=='true'">Exchange Visitor</option>
									<option value="Schengen" *ngIf="visaType=='true'">Schengen</option>
									<option value="Golden" *ngIf="visaType=='true'">Golden</option>
									<option value="Humanitarian" *ngIf="visaType=='true'">Humanitarian</option>
									<option value="Short-Stay" *ngIf="visaType=='true'">Short-Stay</option>
									<option value="Long-Stay" *ngIf="visaType=='true'">Long-Stay</option>
									<option value="Special Talent" *ngIf="visaType=='true'">Special Talent</option>
									<option value="Digital" *ngIf="visaType=='true'">Digital </option>
									<option value="Bridge" *ngIf="visaType=='true'">Bridge </option>
									<option value="Exit" *ngIf="visaType=='true'">Exit</option>
									<option value="Re-Entry" *ngIf="visaType=='true'">Re-Entry</option>
									<option value="Seasonal Worker" *ngIf="visaType=='true'">Seasonal Worker</option>
									<option value="Internship" *ngIf="visaType=='true'">Internship</option>
									<option value="Relocation" *ngIf="visaType=='true'">Relocation</option>
									<option value="Parental" *ngIf="visaType=='true'">Parental</option>
									<option value="Religious Worker" *ngIf="visaType=='true'">Religious Worker</option>
									<option value="Special Purpose" *ngIf="visaType=='true'">Special Purpose</option>
									<option value="Super" *ngIf="visaType=='true'">Super</option>
								</select>

								<input *ngIf="!isTenantIndian" style="text-align: left;width: 200px;" tabIndex="9" tabindex="9" class="input-field" type="text" formControlName="type" />
							</td>
						<td *ngIf="invoiceType=='visa-invoice'">
							
							<ng-container *ngIf="isLocaleDateFormat">
								<input  
									type="date" class="field-input text-center" 
									name="departure_date" formControlName="departure_date" />
							</ng-container>
							<ng-container *ngIf="!isLocaleDateFormat && miscInvoiceService.invoiceForm.controls.departure_date">
								<app-date-time-input
								formControlName="departure_date"
								[dateFormat]="dateFormat"
								[fieldController]="miscInvoiceService.invoiceForm.controls.departure_date"
								class="new-date-input"
								classes="field-input text-center" 
								styles="min-width: -webkit-fill-available;"
								></app-date-time-input>
							</ng-container>
						</td>
						<td *ngIf="invoiceType=='visa-invoice'">
							
							<ng-container *ngIf="isLocaleDateFormat">
								<input  style="min-width: -webkit-fill-available;"
									type="date" class="field-input text-center" (change)="getTotalDays()"
									name="arrival_date" formControlName="arrival_date"/>
							</ng-container>
							<ng-container *ngIf="!isLocaleDateFormat && miscInvoiceService.invoiceForm.controls.departure_date">
								<app-date-time-input
								formControlName="departure_date"
								(change)="getTotalDays($event)"
								[dateFormat]="dateFormat"
								[fieldController]="miscInvoiceService.invoiceForm.controls.departure_date"
								class="new-date-input"
								classes="field-input text-center" 
								styles="min-width: -webkit-fill-available;"
								></app-date-time-input>
							</ng-container>
						</td>
						<td style="width:55px" *ngIf="invoiceType=='visa-invoice'">
							<input  style="width:55px" 
								type="text" formControlName="total_days"
								name="total_days" disabled />
						</td>
					</tr>
					</tbody>
				</table>

			

				<table *ngIf="miscInvoiceService.invoiceForm" class="table table-hovered table-bordered top-miscellaneous-bar">
					<thead>
						<tr *ngIf="salesPersonConfig=='true'||referredByConfig=='true'||costCenterConfig=='true'|| serviceConfig=='true'">
							<th *ngIf="serviceConfig=='true'" class="text-left" style=" width: 110px;">Country</th>
							<th *ngIf="salesPersonConfig=='true'" class="text-left" >sales executive</th>
							<th *ngIf="referredByConfig=='true'" class="text-left" >Referred By</th>
							<th *ngIf="costCenterConfig=='true'" class="text-left" >COST CENTER</th>
					</tr>
				</thead>
				<tbody>
					<td *ngIf="serviceConfig=='true'">
						<ng-multiselect-dropdown [formControl]="miscInvoiceService.invoiceForm.get('country')"  [settings]="dropdownSettings"  
						[data]="countryArr"  (onSelect)="onItemSelect($event)"  (onSelectAll)="onSelectAll($event)" >
						</ng-multiselect-dropdown>						
					</td>
					<td *ngIf="salesPersonConfig=='true'">
						<input #salesPersonAC style="text-transform: uppercase;" 
							type="text" 
							oninput="this.value = this.value.toUpperCase()" 
							name="sales_person_name"
							formControlName="sales_person_name"
							
							(input)="salesPersonSearch($event)"
							[nzAutocomplete]="salesPersonAuto"
							(blur)="validateSalesPerson(salesPersonAC.value)"
						/>

						<nz-autocomplete #salesPersonAuto [nzBackfill]="true" (selectionChange)="selectSalesPerson($event,'sales_person_name')">
							<nz-auto-option  *ngFor="let item of salesPersonArr" [nzValue]="item" [nzLabel]="item.t_user_name"
							 >
								<a innerHTML='<span class="colr-1 selected-ng">{{item.t_user_name}}({{item.user_code}})</span><br />'></a>                           
							</nz-auto-option>                      
						</nz-autocomplete>
					</td>
					<td *ngIf="referredByConfig=='true'">
						<input #referedByAC style="text-transform: uppercase;width: 100%" 
							type="text" 
							oninput="this.value = this.value.toUpperCase()" 
							name="refered_by_name"
							[formControl]="miscInvoiceService.invoiceForm.get('refered_by_name')" 
							
							(input)="referedBySearch($event)"
							[nzAutocomplete]="referedByAuto"
							(blur)="validateReferedby(referedByAC.value)"
						/>

						<nz-autocomplete #referedByAuto [nzBackfill]="true" (selectionChange)="selectReferedBy($event,'refered_by_name')">
							<nz-auto-option  class="colr-1" *ngFor="let item of referedByArr" [nzValue]="item" [nzLabel]="item.name"
								>
								<a innerHTML='<span class="colr-1 selected-ng">{{item.name}}({{item.account_code}})</span><br />'></a>                           
							</nz-auto-option>                      
						</nz-autocomplete>
					</td>
					<td *ngIf="costCenterConfig=='true'">
						<input #costCenterAC style="text-transform: uppercase;width: 100%" 
							type="text" 
							oninput="this.value = this.value.toUpperCase()" 
							name="invoice_cost_center"
							formControlName="invoice_cost_center"
							(input)="costCenterSearch($event)"
							[nzAutocomplete]="costCenterAuto"
							(blur)="validateCostCenter(costCenterAC.value)"
						/>
						<nz-autocomplete #costCenterAuto [nzBackfill]="true" >
							<nz-auto-option  class="colr-1" *ngFor="let item of groupList" [nzValue]="item.name" [nzLabel]="item.name"
							>
								<a innerHTML='<span class="colr-1 selected-ng">{{item.name}}</span><br />'></a>                           
							</nz-auto-option>                      
						</nz-autocomplete>
					</td>
				</tbody>
			</table>
		</div>

			<form [formGroup]="miscInvoiceService.travellerForm" *ngIf="miscInvoiceService.travellerList != undefined">

				<div class="traveller-outer-container"
					[ngClass]="maximizedSection ? 'traveller-outer-container section-maximized ' : 'traveller-outer-container  '">
					
						<div class="d-flex align-items-center justify-content-between" [ngClass]="maximizedSection ? ' section-head-full' : 'section-head text-grey'">
							<span [ngClass]="maximizedSection ? 'section-head text-black ' : 'section-head text-grey'">Services</span><span (click)="minimizeSection()" *ngIf="maximizedSection" class="minimize"><i
								class="fas fa-compress-arrows-alt mr-3"></i>Minimize</span>
						</div>
					<div  class="traveller-section "
						[ngClass]="maximizedSection ? ' maximized-modal' : 'traveller-section'">
			
						<div class="traveller-col miscInvoiceServiceContainer">
							<table style="table-layout: fixed;" class="table table-hovered table-bordered w-100">
								<thead>
									<tr>
										<th style="width: 30px;">#</th>
										<th class="text-left" style=" width: 120px;">Service Name</th>
										<th *ngIf="corporate_employee=='false'" class="text-left" style=" width: 130px;">Lead Traveller</th>
										<th *ngIf="corporate_employee=='true'" class="text-left" style=" width: 130px;">Lead Traveller</th>
										<th *ngIf="corporate_employee=='true'" class="text-left" style=" width: 110px;">E CODE</th>
										<th *ngIf="IncomeSetOff=='true'" style=" width: 140px;" >General Ledger</th>
										<!-- <th class="text-left" style=" width: 70px;">HSN</th> -->
										<th class="text-left" style=" width: 40px;">QTY</th>
										<th class="text-left"  >Ref</th>
										
										<th style=" width: 80px;">Pay Type</th>
										<th style=" width: 130px;">Card</th>
										<th style=" width: 90px;">Payable Type</th>
										<th style=" width: 140px;">Payable</th>
										<th *ngIf="associate_supp=='true'" style="width:140px;" >Associate Supplier</th>
										<th *ngIf="supplier_trans=='true'" class="text-left" style="width: 110px;">Payable Trans. No.</th>
										<th *ngIf="supplier_trans=='true'" class="text-center" style=" width: 90px;" >Payable Date</th>
										<!-- <th style=" width: 90px;" class="text-right">Basic</th>
										<th style=" width: 90px;" class="text-right">Tax</th> -->
										<!-- <th  class="text-right">TDS</th>
										<th  class="text-right" *ngIf="isTenantIndian">GST</th>
										<th  class="text-right" *ngIf="!isTenantIndian">{{vatAlternetname}}</th>
										<th  class="text-right">Total</th> -->
										<th style=" width: 90px;">Action</th>
									</tr>
								</thead>
								<tbody formArrayName="travellerList">
									<ng-container *ngFor="let travellers of DynamicFormControls.controls; let i = index">
										<ng-container [formGroupName]="i">
											<tr class=" _tablServicese_row">
												<td style="width: 30px; " class="text-center">
													{{i+1}}
												</td>
												<td *ngIf="serviceConfig=='false'">
													<input 
													tabIndex="{{i*totalInputInTravellers+staticInputCount+1}}"  
													attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+1}}"
													oninput="this.value = this.value.toUpperCase()"
													(focus)="handleMaximizeSection(i)"
													type="text" class="w-100" formControlName="service_name" />
												</td>
												<td *ngIf="serviceConfig=='true'">
													<select 
													tabIndex="{{i*totalInputInTravellers+staticInputCount+1}}"  
													attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+1}}"
													type="text" class="w-100" formControlName="service_name"  >
													<option value="">Select</option>
													<option value="VFS APPOINTMENT">VFS APPOINTMENT</option>
													<option value="VISA STAMPING">VISA STAMPING</option>
													<option value="MEDICAL APPOINTMENT">MEDICAL APPOINTMENT</option>
													<option value="Adult Passport">Adult Passport(PASSPORT SERVICE)</option>
													<option value="Infant & Child Passport">Infant & Child Passport(PASSPORT SERVICE)</option>
													<option value="Additional Page with New Passport">Additional Page with New Passport(PASSPORT SERVICES)</option>
													<option value="New Passport for Damaged Passport">New Passport for Damaged Passport(PASSPORT SERVICES)</option>
													<option value="Passport Renewal">Passport Renewal(PASSPORT SERVICES)</option>
													<option value="Add Spouse Name">Add Spouse Name(PASSPORT SERVICES)</option>
													<option value="Change of Address & Name">Change of Address & Name(PASSPORT SERVICES)</option>
													<option value="JUMBO PASSPORT">JUMBO PASSPORT</option>
													<option value="PASSPORT SURRENDER">PASSPORT SURRENDER</option>
													<option value="SPECIAL PASSPORT">SPECIAL PASSPORT</option>
													<option value="INDIAN PCC">INDIAN PCC</option>
													<option value="HRD ATTESTATION">HRD ATTESTATION</option>
													<option value="PCC - OTHER COUNTRIES">PCC - OTHER COUNTRIES</option>
													<option value="ATTESTATION">ATTESTATION</option>
													<option value="TRANSLATION">TRANSLATION</option>
													<option value="COURIER SERVICES">COURIER SERVICES</option>
													<option value="REGISTRATION FEE">REGISTRATION FEE</option>
													<option value="APPLICATION FEE">APPLICATION FEE</option>
													<option value="AFFIDAVIT">AFFIDAVIT</option>
													<option value="PCC">PCC</option>
													<option value="UNI ASST">UNI ASST</option>
													<option value="GERMAN PUBLIC UNIVERSITY">GERMAN PUBLIC UNIVERSITY</option>
													<option value="CAMPUS FRANCE">CAMPUS FRANCE</option>
													<option value="SERVIS FEES-USE">SERVIS FEES-USE</option>
													<option value="APS CERTIFICATION">APS CERTIFICATION</option>
													<option value="BIRTH CERTIFICATE">BIRTH CERTIFICATE</option>
													<option value="German Ausbildung Service charge">German Ausbildung Service charge</option>
													<option value="UCAS">UCAS</option>
													<option value="Dulingo online Coaching">Dulingo online Coaching</option>
													<option value="IELTS Date booking">IELTS Date booking</option>
													<option value="IELTS Date Coaching">IELTS Date Coaching</option>
													<option value="PTE date booking">PTE date booking</option>
													<option value="PTE Online coaching">PTE Online coaching</option>
													<option value="Screening form fee">Screening form fee</option>
													<option value="Aptitude DIT fees">Aptitude DIT fees</option>
													<option value="Medical Booking">Medical Booking</option>
													<option value="Passport Submission">Passport Submission</option>
													<option value="Apostille">Apostille</option>
													<option value="Tour">Tour</option>
													<option value="VISA APPLICATION FEE" >VISA APPLICATION FEE </option>
													<option value="E-VISA" >E-VISA </option>
													<option value="F R R O SERVICES" >F R R O SERVICES</option>
													<option value="INDIAN E VISA" >INDIAN E VISA</option>
													<option value="OCI CARD SERVICES" >OCI CARD SERVICES</option>
													<option value="USA PASSPORT COLLECTION - V.F.S" >USA PASSPORT COLLECTION - V.F.S</option>
													<option value="USA PASSPORT SUBMISSION - V.F.S" >USA PASSPORT SUBMISSION - V.F.S</option>
													<option value="NUNCIO" >NUNCIO</option>
													<option value="AU PAIR" >AU PAIR</option>
													<option value="AUSBILDUNG" >AUSBILDUNG</option>
													<option value="FAMILY REUNION">FAMILY REUNION</option>
													<option value="Accommodation">Accommodation</option>
													<option value="Japan language Online Coaching">Japan language Online Coaching</option>
													<option value="Airport Lounge Access">Airport Lounge Access</option>
													<option value="Airport Assistance ">Airport Assistance </option>
													<option value="Sport">Sport</option>
													<option value="Concert">CONCERT</option>
													<option value="Trip Add">TRIP ADD</option>
													<option value="Cruise">CRUISE</option>
													<option value="eSIM">eSIM</option>
													<option value="Activity">ACTIVITY</option>
													
													</select>
												</td>
												
												<td *ngIf="corporate_employee=='false'"> 
													<input 
													tabIndex="{{i*totalInputInTravellers+staticInputCount+2}}"  
													attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+2}}"
													oninput="this.value = this.value.toUpperCase()"
													(focus)="handleMaximizeSection(i)"
													type="text" class="w-100" formControlName="lead_pax_name" />
												</td>
												<td *ngIf="corporate_employee=='true'"> 
													<div class="autocomplete-container">
														<div class="w-100" (focus)="focusCorporateEmployeeAc()"  >
													<input #corporateEmployeeAc
													tabIndex="{{i*totalInputInTravellers+staticInputCount+2}}"  
													attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+2}}"
													oninput="this.value = this.value.toUpperCase()"
													type="text" class="w-100" formControlName="lead_pax_name"
													(input)="getCorporateEmployee($event, i)"
													(focus)="handleMaximizeSection(i)"
													 [nzAutocomplete]="employeeAutoComplete" />
													</div>
													<nz-autocomplete #employeeAutoComplete [nzBackfill]="true" (selectionChange)="selectEmployee($event, i)" >
														<nz-auto-option class="colr-1" *ngFor="let item of employeeArr" [nzValue]="item" [nzLabel]="item.account_name " >
															<a innerHTML='<span class="colr-1">{{item?.account_name}}
																	({{item?.account_code}})</span>'>
															</a>                           
														</nz-auto-option>                      
												</nz-autocomplete>
													</div>
												</td>
												<td *ngIf="corporate_employee=='true'"><input
													oninput="this.value = this.value.toUpperCase()"
													formControlName="e_code" maxlength="70" disabled
													class="w-100"
													type="text" 
													/>
											</td >
												<td *ngIf="IncomeSetOff=='true'" tabIndex="{{i*totalInputInTravellers+staticInputCount+3}}"  
												attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+3}}"
												(focus)="focusLedgerCardAc()">
													<ng-autocomplete [data]="bookingGenerlaAccountArr" #generalLedgerAc formControlName="general_ledger_code_name"
														[searchKeyword]="keyword" (selected)="selectAccount($event,'general_ledger_code', null)"
														(inputChanged)='generalSearch($event,false,true)' (inputFocused)='onFocused($event)'
														(inputCleared)="selectAccount($event,'general_ledger_code', null)"
														[itemTemplate]="itemTemplate" [notFoundTemplate]="notFoundTemplate">
													</ng-autocomplete>

													<ng-template #itemTemplate let-item>
														<a innerHTML='<span class="colr-1">{{item?.name}}
															({{item?.account_code}})</span>'>
														</a>
													</ng-template>

													<ng-template #notFoundTemplate let-notFound>
														<div [innerHTML]="notFound"></div>
													</ng-template>
												</td>
												
												
												<!-- <td>
												
													<input 
													tabIndex="{{i*totalInputInTravellers+staticInputCount+4}}"  
													attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+4}}"
													(focus)="handleMaximizeSection(i)"
													type="text" class="w-100" maxlength="15" formControlName="hsn"/>
												</td> -->
												<td>
												
													<input 
													tabIndex="{{i*totalInputInTravellers+staticInputCount+5}}"  
													attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+5}}"
													(focus)="handleMaximizeSection(i)"
													type="text" class="w-100" maxlength="15" formControlName="quantity"/>
												</td>
												<td>
													
													<input 
													tabIndex="{{i*totalInputInTravellers+staticInputCount+6}}"  
													attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+6}}"
													(focus)="handleMaximizeSection(i)"
													type="text" class="w-100" maxlength="15" formControlName="reference_number"/>
												</td>
			
												
												
			
			
												<td>
													<select 
													tabIndex="{{i*totalInputInTravellers+staticInputCount+7}}"  
													attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+7}}"
													class="select-input w-100" formControlName="pay_type" (change)="handlePayTypeChange($event,i)" (click)="handlePayTypeChange($event,i)">
														<option value="">Select</option>
														<option value="OUR_CC">Our CC</option>
														<option value="AGENT_CC">Agent CC</option>
														<option value="ASSOCIATE_CC">ASSOCIATE CC</option>
													</select>
												</td>
												
												<td 
												(focus)="focusLedgerCardAc()"
													style="text-align: left;">
													<ng-autocomplete [data]="generalAccountArr" #ledgerCardAC formControlName="ledger_card_name"
														[searchKeyword]="keyword" (selected)="selectAccount($event,'ledger_card_no', i)"
														(inputFocused)='onFocused($event)'
														(inputCleared)="selectAccount($event,'ledger_card_no', i)"
														[disabled]="travellers.value.pay_type != 'OUR_CC' && travellers.value.pay_type != 'ASSOCIATE_CC' "
														[itemTemplate]="itemTemplate" [notFoundTemplate]="notFoundTemplate">
													</ng-autocomplete>

													<ng-template #itemTemplate let-item>
														<a innerHTML='<span class="colr-1">{{item?.name}}
															({{item?.account_code}})</span>'>
														</a>
													</ng-template>

													<ng-template #notFoundTemplate let-notFound>
														<div [innerHTML]="notFound"></div>
													</ng-template>

												</td>

												<td>
													<select 
													tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC' ? 7 : 8 )}}"  
													attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC' ? 7 : 8 )}}"
													class="select-input w-100" formControlName="payable_account_type">
													<option value="">Select</option>
													<option value="client">Client</option>
													<option value="airline">Airline</option>
													<option value="supplier">Supplier</option>
													<option value="employee">Employee</option>
													<option value="general">General</option>
													</select>
												</td>

												<td 
													style="text-align: left;" [ngClass]="{'error-box': travellers.controls.payable_account_name.dirty && !travellers.controls.payable_account_name.valid}">
													<ng-autocomplete [data]="payablesArr" formControlName="payable_account_name"
														tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 8 : 9)}}"  
														attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 8 : 9)}}"
														[searchKeyword]="keyword" (selected)="selectAccount($event,'payable_code', i)"
														(inputChanged)="payableSearch($event, i)" (inputFocused)='onFocused($event)'
														(inputCleared)="selectAccount($event,'payable_code', i)"
														[itemTemplate]="itemTemplate" [notFoundTemplate]="notFoundTemplate">
													</ng-autocomplete>

													<ng-template #itemTemplate let-item>
														<a innerHTML='<span class="colr-1">{{item?.name}}
															({{item?.account_code}})</span>'>
														</a>
													</ng-template>

													<ng-template #notFoundTemplate let-notFound>
														<div [innerHTML]="notFound"></div>
													</ng-template>

												</td>

												<td *ngIf="associate_supp=='true'" 
													style="text-align: left;" [ngClass]="{'error-box': travellers.controls.associate_payable_account_name.dirty && !travellers.controls.associate_payable_account_name.valid}">
													<ng-autocomplete [data]="associatePayablesArr" formControlName="associate_payable_account_name"
													[disabled]="!travellers.value.payable_account_is_branch"
														[searchKeyword]="keyword" (selected)="selectAccount($event,'associate_payable_code', i)"
														(inputChanged)="associatePayableSearch($event, i)" (inputFocused)='onFocused($event)'
														(inputCleared)="selectAccount($event,'associate_payable_code', i)"
														[itemTemplate]="associateItemTemplate" [notFoundTemplate]="notFoundTemplate">
													</ng-autocomplete>

													<ng-template #associateItemTemplate let-item>
														<a innerHTML='<span class="colr-1">{{item?.name}}
															({{item?.account_code}})</span>'>
														</a>
													</ng-template>

													<ng-template #notFoundTemplate let-notFound>
														<div [innerHTML]="notFound"></div>
													</ng-template>

												</td>
												<td *ngIf="supplier_trans=='true'">
													<input 
													oninput="this.value = this.value.toUpperCase()"
													(focus)="maximizeSection(i,4)"
													type="text" class="w-100" maxlength="50" formControlName="payable_transaction_code"/>
												</td>
		
												<td *ngIf="supplier_trans=='true'"> 
													<ng-container *ngIf="isLocaleDateFormat">
														<input 
															type="date" style="width: 86px!important;"   
															(focus)="maximizeSection(i,2)" 
															class="field-input w-100" formControlName="payable_date" />
													</ng-container>
													<ng-container *ngIf="!isLocaleDateFormat && travellers.controls.payable_date">
														<app-date-time-input
														formControlName="payable_date"
														(blur)="maximizeSectionDate($event,i,2)"
														[dateFormat]="dateFormat"
														[fieldController]="travellers.controls.payable_date"
														class="new-date-input"
														classes="field-input w-100" 
														styles="width: 86px!important;"
														></app-date-time-input>
													</ng-container>
															
														</td>

												
<!-- 			
												<td>
													<input type="text" class="w-100 text-right" disabled value="{{travellers.value.client_basic}}" />
												</td>
												<td>
													<input type="text" class="w-100 text-right" disabled  value="{{travellers.value.client_taxes}}"/>
												</td> -->
												<!-- <td>
													<input type="text" class="w-100 text-right" disabled  value="{{travellers.value.client_tds_amount}}"/>
												</td>
												<td *ngIf="isTenantIndian">
													<input type="text" class="w-100 text-right" disabled  value="{{travellers.value.client_sgst + travellers.value.client_cgst + travellers.value.client_igst}}"/>
												</td>
												<td *ngIf="!isTenantIndian">
													<input type="text" class="w-100 text-right" disabled  value="{{travellers.value.client_vat_amount}}"/>
												</td>
												<td>
													<input type="text" class="w-100 text-right" disabled  value="{{travellers.value.client_net_amount}}"/>
												</td> -->
			
												<td class="hilight">
													<span class="action-col d-flex">
														<button title="Maximize" class=" custom-table-btn mr-2 bg-white border-0 p-0 text-bold hoverableShadow transition cursor" type="button" (click)="maximizeSection(i, staticInputCount == 13 ? 2 : 1)"  id="edit_traveller_{{i}}_btn">
														<img src="{{commonService.aws_asset_url}}/_assets/icons/light-mode/dark-edit-btn.svg" alt="" width="20px">
														</button>
														<button title="Delete" class=" custom-table-btn mr-2 bg-white border-0 p-0 text-bold hoverableShadow transition cursor" type="button"
														(click)="miscInvoiceService.removeTraveller(i)" >
															<img src="{{commonService.aws_asset_url}}/_assets/icons/light-mode/dark-delete.svg" alt="" width="20px">
														</button>
													</span>
												</td>
											</tr>
			
											<ng-container *ngIf="showTravellerIndex == i">

												<tr>
													<td colspan="4">
														<div>
															<span class="section-head text-left">Service Details</span>
															<input formControlName="service_details_1"
															[ngClass]="{'error-field': !travellers.controls.service_details_1.valid && travellers.controls.service_details_1.hasError('pattern')}"
															
															tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 9 : 10)}}"  
															attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 9 : 10)}}"
															type="text"
															maxlength="50"
															class="border-bottom-0 d-block p-2 w-100 bbrr bblr">
															<input formControlName="service_details_2"
															[ngClass]="{'error-field': !travellers.controls.service_details_2.valid && travellers.controls.service_details_2.hasError('pattern')}"
															
															tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 10 : 11)}}"  
															attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 10 : 11)}}"
															type="text"
															maxlength="50"
															class="border-bottom-0 border-top-0 d-block mt-0 p-2 w-100 br0">
															<input formControlName="service_details_3"
															[ngClass]="{'error-field': !travellers.controls.service_details_3.valid && travellers.controls.service_details_3.hasError('pattern')}"
															
															tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 11 : 12)}}"  
															attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 11 : 12)}}"
															type="text"
															maxlength="50"
															class="border-bottom-0 border-top-0 d-block mt-0 p-2 w-100 br0">
															<input formControlName="service_details_4"
															[ngClass]="{'error-field': !travellers.controls.service_details_4.valid && travellers.controls.service_details_4.hasError('pattern')}"
															
															tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 12 : 13)}}"  
															attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 12 : 13)}}"
															type="text"
															maxlength="50"
															class="border-bottom-0 border-top-0 d-block mt-0 p-2 w-100 br0">
															<input formControlName="service_details_5"
															[ngClass]="{'error-field': !travellers.controls.service_details_5.valid && travellers.controls.service_details_5.hasError('pattern')}"
															
															tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 13 : 14)}}"  
															attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 13 : 14)}}"
															type="text"
															maxlength="50"
															class="border-top-0 d-block p-2 w-100 btrr btlr">
															<span class="text-dark-orange"
																*ngIf=" (
																			!travellers.controls.service_details_1.valid && travellers.controls.service_details_1.hasError('pattern')
																		) ||
																		(
																			!travellers.controls.service_details_2.valid && travellers.controls.service_details_2.hasError('pattern')
																		) ||
																		(
																			!travellers.controls.service_details_3.valid && travellers.controls.service_details_3.hasError('pattern')
																		) ||
																		(
																			!travellers.controls.service_details_4.valid && travellers.controls.service_details_4.hasError('pattern')
																		) ||
																		(
																			!travellers.controls.service_details_5.valid && travellers.controls.service_details_5.hasError('pattern')
																		)
																	">
																Invalid special chars</span>
														</div>
													</td>
													<td colspan="9">
														<span class="section-head text-left">Fare Breakup</span>
														<table class="table table-hovered table-bordered fare-breakup-table mb-0">
															<thead>
																<tr>
																	<th></th>
																	<th class="client">Client</th>
																	<th class="supplier">Supplier </th>
																</tr>
															</thead>
															<tbody>
																<tr>
																	<td class="text-right">
																		Basic
																	</td>
																	<td>
																		<input 
																		[attr.disabled]="miscInvoiceService.invoiceForm.value.sub_invoice_type == 'tour'?true:null"
																		tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 14 : 15)}}"  
																		attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 14 : 15)}}"
																		formControlName="client_basic"
																			(input)="replicateClientAmount(i,'client_basic','supplier_basic')" class="traveller-input-field  text-right"
																			type="text" />
																	</td>
																	<td>
																		<input 
																		tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 15 : 16)}}"  
																		attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 15 : 16)}}"
																		formControlName="supplier_basic"
																	     	(input)="isTenantIndian && miscInvoiceService.invoiceForm.value.sub_invoice_type != 'tour' ? calculateNetAmount(i) : replicateClientAmount(i,'supplier_basic','client_basic')" class="traveller-input-field  text-right"
																			type="text"  />
																	</td>
																</tr>
									
																<tr>
																	<td class="text-right">
																		Taxes
																	</td>
																	<td>
																		<input 
																		[attr.disabled]="miscInvoiceService.invoiceForm.value.sub_invoice_type == 'tour'?true:null"
																		tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 16 : 17)}}"  
																		attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 16 : 17)}}"
																		 formControlName="client_taxes"
																		 (input)="replicateClientAmount(i,'client_taxes','supplier_taxes')"
																		 class="traveller-input-field  text-right"
																			type="text" />
																	</td>
																	<td>
																		<input 
																		tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 17 : 18)}}"  
																		attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 17 : 18)}}"
																		formControlName="supplier_taxes"
																		    (input)="isTenantIndian && miscInvoiceService.invoiceForm.value.sub_invoice_type != 'tour' ? calculateNetAmount(i) : replicateClientAmount(i,'supplier_taxes','client_taxes')" class="traveller-input-field  text-right"
																			type="text" />
																	</td>
																</tr>
																<tr>
																	<td class="text-right">
																		Commission
																	</td>
																	<td>
																		<div class="three-fields">
																			<select 
																			[attr.disabled]="miscInvoiceService.invoiceForm.value.sub_invoice_type == 'tour'?true:null"
																			tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 18 : 19)}}"  
																			attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 18 : 19)}}"
																			class="inner-select-top w-50"
																				formControlName="client_commission_type"
																				(change)="calculateNetAmount(i)">
																				<option  *ngIf="isTenantIndian" value="RB">RB</option>
																				<option  *ngIf="isTenantIndian" value="RT">RT</option>
																				<option value="VL">VL</option>
																			</select>
																			<input 
																			[attr.disabled]="miscInvoiceService.invoiceForm.value.sub_invoice_type == 'tour'?true:null"
																			tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 19 : 20)}}"  
																			attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 19 : 20)}}"
																			style="width: 65px!important;"
																				formControlName="client_commission_value"
																				class="traveller-input-field  text-right w-25" type="text"
																				(input)="calculateNetAmount(i)" />
																			<input 
																			[attr.disabled]="miscInvoiceService.invoiceForm.value.sub_invoice_type == 'tour'?true:null"
																			style="width: 120px!important;"
																				formControlName="client_commission_amount"
																				class="traveller-input-field  text-right w-25" readonly type="text" />
																		</div>
																	</td>
																	<td>
																		<div class="three-fields">
																			<select 
																			tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 20 : 21)}}"  
																			attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 20 : 21)}}"
																			class="inner-select-top w-50"
																				formControlName="supplier_commission_type"
																				(change)="calculateNetAmount(i)">
																				<option  *ngIf="isTenantIndian" value="RB">RB</option>
																				<option  *ngIf="isTenantIndian" value="RT">RT</option>
																				<option value="VL">VL</option>
																			</select>
																			<input 
																			tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 21 : 22)}}"  
																			attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 21 : 22)}}"
																			style="width: 65px!important;"
																				formControlName="supplier_commission_value"
																				class="traveller-input-field  text-right w-25" type="text"
																				(input)="calculateNetAmount(i)" />
																			<input style="width: 120px!important;"
																				formControlName="supplier_commission_amount"
																				class="traveller-input-field  text-right w-25" type="text" readonly />
																		</div>
																	</td>
									
																</tr>
																<tr>
																	<td class="text-right">
																		TDS
																	</td>
																	<td>
																		<div 
																			class="d-flex justify-content-between">
																			<div style="width:24%" class="align-items-center mr-2">
																				<label class="mb-0" title="">TDS On:</label>
																				<select 
																				[attr.disabled]="miscInvoiceService.invoiceForm.value.sub_invoice_type == 'tour'?true:null"
																				tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 22 : 23)}}"  
																				attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 22 : 23)}}"
																				class="inner-select-top w-100"
																					(change)="calculateNetAmount(i)" formControlName="client_tds_type">
																					<option value="C" title="Commission">COMM.</option>
																					<option value="B" title="Basic">Basic</option>
																				</select>
																			</div>
																			<div style="width:24%" class="align-items-center mr-2">
																				<label class="mb-0">TDS Rate:</label>
																				<input 
																				[attr.disabled]="miscInvoiceService.invoiceForm.value.sub_invoice_type == 'tour'?true:null"
																				tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 23 : 24)}}"  
																				attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 23 : 24)}}"
																				 class="traveller-input-field"
																					type="number" formControlName="client_tds_conf"
																					(input)="calculateNetAmount(i)" />
																			</div>
																			<div style="width:24%" class="align-items-center mr-2">
																				<label class="mb-0">Amount</label>
																				<input formControlName="client_tds_amount" readonly
																			class="traveller-input-field  text-right" type="text" />
																			</div>
																		</div>
																	</td>
																	<td>
																		<div 
																			class="d-flex justify-content-between">
																			<div style="width:24%" class="align-items-center mr-2">
																				<label class="mb-0" title=""> On:</label>
																				<select 
																				tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 24: 25)}}"  
																				attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 24: 25)}}"
																				class="inner-select-top w-100"
																					(change)="calculateNetAmount(i)" formControlName="supplier_tds_type">
																					<option value="C" title="Commission">COMM.</option>
																					<option value="B" title="Basic">Basic</option>
																				</select>
																			</div>
																			<div style="width:24%" class="align-items-center mr-2">
																				<label class="mb-0"> Rate:</label>
																				<input 
																				tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 25 : 26)}}"  
																				attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 25 : 26)}}"
																				 class="traveller-input-field"
																					type="number" formControlName="supplier_tds_conf"
																					(input)="calculateNetAmount(i)" />
																			</div>
																			<div style="width:24%" class="align-items-center mr-2">
																				<label class="mb-0">Amount</label>
																				<input formControlName="supplier_tds_amount" readonly
																			class="traveller-input-field  text-right" type="text" />
																			</div>
																		</div>
																	</td>
																</tr>

																<tr *ngIf="discount_add=='true'">
																	<td class="text-right">
																		discount
																	</td>
																	<td>
																		<div class="three-fields">
																			<select 
																			[attr.disabled]="miscInvoiceService.invoiceForm.value.sub_invoice_type == 'tour'?true:null"
																			class="inner-select-top w-50"
																				formControlName="client_discount_type"
																				(change)="calculateNetAmount(i)">
																				<option value="VL">VL</option>
																			</select>
																			<input 
																			[attr.disabled]="miscInvoiceService.invoiceForm.value.sub_invoice_type == 'tour'?true:null"
																			style="width: 120px!important;"
																				formControlName="client_discount_amount"
																				class="traveller-input-field  text-right w-25" type="text"
																				(input)="calculateNetAmount(i)" />
																		</div>
																	</td>
																	<td>
																		<div class="three-fields">
																			<select 
																			class="inner-select-top w-50"
																				formControlName="supplier_discount_type"
																				(change)="calculateNetAmount(i)">
																				<option value="VL">VL</option>
																			</select>
																			<input 
																			style="width: 120px!important;"
																				formControlName="supplier_discount_amount"
																				class="traveller-input-field  text-right w-25" type="text"
																				(input)="calculateNetAmount(i)" />
																			
																		</div>
																	</td>
									
																</tr>

																<!-- service charge 1 -->
																<tr>
																	<td class="text-right">
																		<div class="d-flex justify-content-between">
																			<div class="align-items-center mr-2">
																				<label class="mb-0" title="">Service Charge 1</label>
																				<div class="d-flex justify-content-between" >
																					<div >hsn</div>
																					<input [ngClass]="((travellers.value.client_cgst!=0 || travellers.value.client_sgst!=0 || travellers.value.client_igst!=0) && (!travellers.value.hsn) && (isGstNumberExist==true))?'validateError':''"
																					class="traveller-input-field  text-right w-50" type="text" formControlName="hsn" oninput="this.value = this.value.toUpperCase()" />
																				</div>
																			</div>
																		</div>
																	</td>
																	<td>
																		<div class="d-flex justify-content-between">
																			<div class="align-items-center mr-2">
																				<label class="mb-0" title="">Taxable:</label>

																			<select
																			[attr.disabled]="miscInvoiceService.invoiceForm.value.sub_invoice_type == 'tour'?true:null" 
																			tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 26 : 27)}}"  
																			attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 26 : 27)}}"
																			style="width:40px!important"
																				class="inner-select-top w-50 mr-1" (change)="calculateNetAmount(i)"
																				formControlName="client_sc1_type">
																				<option value="T">T</option>
																				<option value="N">N</option>
																			</select>
																		</div>
																		<div style="width:24%" class="align-items-center mr-2">
																			<label class="mb-0" title="">AMT:</label>

																			<input 
																			[attr.disabled]="miscInvoiceService.invoiceForm.value.sub_invoice_type == 'tour'?true:null"
																			tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 27 : 28)}}"  
																			attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 27 : 28)}}"
																			formControlName="client_sc1_amount"
																			(change)="changeAmount('client_sc1_amount',i)"
																				class="traveller-input-field  text-right w-100" type="text" />
																		</div>
																		<ng-container *ngIf="isTenantIndian">
																			<div style="width:24%" class="align-items-center mr-2">
																				<label class="mb-0" title="">GST On:</label>
																				<select 
																				[attr.disabled]="miscInvoiceService.invoiceForm.value.sub_invoice_type == 'tour'?true:null"
																				class="inner-select-top w-100"
																				tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 28 : 29)}}"  
																				attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 28 : 29)}}"
																					(change)="calculateNetAmount(i)" formControlName="client_gst_type">
																					<option title= 'S' value="S">SC1</option>
																					<option disabled title= 'B' value="B">B</option>
																					<option disabled title= 'TOTAL' value="TOTAL">TOTAL</option>
																				</select>
																			</div>

																			<div style="width:24%" class="align-items-center mr-2">
																				<label class="mb-0">GST Rate:</label>
																				<select 
																				[attr.disabled]="miscInvoiceService.invoiceForm.value.sub_invoice_type == 'tour'?true:null"
																					class="traveller-input-field"
																					tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 29 : 30)}}"  
																					attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 29 : 30)}}"
																					type="number" formControlName="client_gst_conf"
																					(change)="calculateNetAmount(i)" >
																					<option value= 0 >0</option>
																					<option value= 5 >5</option>
																					<option value=12 >12</option>
																					<option value=18 >18</option>
																					<option value=28 >28</option>
																				</select>
																			</div>

																			<div style="width:24%" class="align-items-center mr-2">
																				<label class="mb-0">CGST</label>
																				<input disabled formControlName="client_cgst" class="traveller-input-field"
																					type="number" />
																			</div>

																			<div style="width:24%" class="align-items-center mr-2">
																				<label class="mb-0 ml-1 mr-1">SGST</label>
																				<input disabled formControlName="client_sgst" class="traveller-input-field"
																					type="number" />
																			</div>

																			<div style="width:24%" class="align-items-center">
																				<label class="mb-0">IGST</label>
																				<input disabled formControlName="client_igst" class="traveller-input-field"
																					type="number" />
																			</div>
																		</ng-container>
																		</div>
																	</td>
																	<td>
																		<div class="d-flex justify-content-between">
																			<div class="align-items-center mr-2">
																				<label class="mb-0" title="">Taxable:</label>

																			<select 
																			tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 30 : 31)}}"  
																			attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 30 : 31)}}"
																			style="width:40px!important"
																				class="inner-select-top w-50 mr-1" (change)="calculateNetAmount(i)"
																				formControlName="supplier_sc1_type">
																				<option value="T">T</option>
																				<option value="N">N</option>
																			</select>
																		</div>
																		<div style="width:24%" class="align-items-center mr-2">
																			<label class="mb-0" title="">AMT:</label>

																			<input 
																			tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 31 : 32)}}"  
																			attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 31 : 32)}}"
																			formControlName="supplier_sc1_amount"
																			(change)="changeAmount('supplier_sc1_amount',i)"
																				class="traveller-input-field  text-right w-100" type="text" />
																			</div>
																			<ng-container *ngIf="isTenantIndian">
																				<div style="width:24%" class="align-items-center mr-2">
																					<label class="mb-0" title="">GST On:</label>
																					<select 
																					class="inner-select-top w-100"
																				     	tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 32 : 33)}}"  
																					    attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 32 : 33)}}"
																						(change)="calculateNetAmount(i)" formControlName="supplier_gst_type">
																						<option title= 'S' value="S">SC1</option>
																						<option disabled title= 'B' value="B">B</option>
																						<option disabled title= 'T' value="T">OT</option>
																					</select>
																				</div>
																				<div style="width:24%" class="align-items-center mr-2">
																					<label class="mb-0">GST Rate:</label>
																					<select 
																					    tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 33 : 34)}}"  
																					    attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 33 : 34)}}"
																						class="traveller-input-field" type="number"
																						formControlName="supplier_gst_conf" 
																						(change)="calculateNetAmount(i)" >
																						<option value= 0 >0</option>
																						<option value= 5 >5</option>
																						<option value=12 >12</option>
																						<option value=18 >18</option>
																						<option value=28 >28</option>
																					</select>
																				</div>
																				<div style="width:24%" class="align-items-center mr-2">
																					<label class="mb-0">CGST</label>
																					<input disabled formControlName="supplier_cgst"
																						class="traveller-input-field" type="number" />
																				</div>
																				<div style="width:24%" class="align-items-center mr-2">
																					<label class="mb-0 ml-1 mr-1">SGST</label>
																					<input disabled formControlName="supplier_sgst"
																						class="traveller-input-field" type="number" />
																				</div>
																				<div style="width:24%" class="align-items-center">
																					<label class="mb-0">IGST</label>
																					<input disabled formControlName="supplier_igst"
																						class="traveller-input-field" type="number" />
																				</div>
																		    </ng-container>

																		</div>
																	</td>
																</tr>
									
																<tr *ngIf="(travellers.value.supplier_sc1_type == 'T' ||
																travellers.value.client_sc1_type == 'T') && !isTenantIndian">
																	<td class="text-right" *ngIf="isTenantIndian">
																		GST
																	</td>
																	<td class="text-right" *ngIf="!isTenantIndian">
																		{{vatAlternetname}}
																	</td>
									
																	<td>

																		<div *ngIf="(travellers.value.client_sc1_type == 'T') && (!isTenantIndian)"
																			class="d-flex justify-content-between">
																			<div style="width:24%" class="align-items-center mr-2">
																				<label class="mb-0" title="">{{vatAlternetname}} On:</label>
																				<select 
																				tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 28 : 29)}}"  
																				attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 28 : 29)}}"
																				class="inner-select-top w-100"
																					(change)="calculateNetAmount(i)" formControlName="client_vat_type">
																					<option value="S">S</option>
																					<option value="B">B</option>
																					<option value="T">T</option>
																				</select>
																			</div>
																			<div style="width:24%" class="align-items-center mr-2">
																				<label class="mb-0">Rate:</label>
																				<input 
																				tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 29 : 30)}}"  
																				attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 29 : 30)}}"
																				 class="traveller-input-field"
																					type="number" formControlName="client_vat_conf"
																					(input)="calculateNetAmount(i)" />
																			</div>
																			<div style="width:24%" class="align-items-center mr-2">
																				<label class="mb-0">Amount:</label>
																				<input disabled formControlName="client_vat_amount" class="traveller-input-field"
																					type="number" />
																			</div>
																		</div>

																	</td>

																	<td *ngIf="(travellers.value.supplier_sc1_type == 'T' )&& (!isTenantIndian) ">
																		<div>
									
																			<div class="d-flex justify-content-between">
																				<div style="width:24%" class="align-items-center mr-2">
																					<label class="mb-0" title="">{{vatAlternetname}} On:</label>
																					<select 
																					tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 32 : 33)}}"  
																					attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 32 : 33)}}"
																					class="inner-select-top w-100"
																						(change)="calculateNetAmount(i)" formControlName="supplier_vat_type">
																						<option value="S">S</option>
																						<option value="B">B</option>
																						<option value="T">T</option>
																					</select>
																				</div>
																				<div style="width:24%" class="align-items-center mr-2">
																					<label class="mb-0">Rate:</label>
																					<input 
																					tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 33 : 34)}}"  
																					attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 33 : 34)}}"
																					(input)="calculateNetAmount(i)" 
																						class="traveller-input-field" type="number"
																						formControlName="supplier_vat_conf" />
																				</div>
																				<div style="width:24%" class="align-items-center mr-2">
																					<label class="mb-0">Amount:</label>
																					<input disabled formControlName="supplier_vat_amount"
																						class="traveller-input-field" type="number" />
																				</div>
																			</div>
																		</div>
																	</td>
									
																</tr>
																<!-- service charge 2 -->
																<tr>
																	<td class="text-right">
																		<div class="align-items-center mr-2">
																			<label class="mb-0" title="">Service Charge 2</label>
																			<ng-container *ngIf="isTenantIndian">
																			<div class="d-flex justify-content-between" >
																				<div >hsn</div>
																				<input [ngClass]="((travellers.value.client_cgst_2!=0 || travellers.value.client_sgst_2!=0 || travellers.value.client_igst_2!=0 || (travellers.value.client_sc2_taxable=='T' && travellers.value.client_sc2_amount!=0)) && (!travellers.value.hsn_2)&&(isGstNumberExist==true))?'validateError':''"
																				class="traveller-input-field  text-right w-50" type="text" formControlName="hsn_2" oninput="this.value = this.value.toUpperCase()" />
																			</div>
																		</ng-container>
																		</div>

																	</td>
																	<td>
																		<div class="d-flex justify-content-between">
																			<div class="align-items-center mr-2">
																				<label class="mb-0" title="">Taxable:</label>
																				<select 
																				[attr.disabled]="miscInvoiceService.invoiceForm.value.sub_invoice_type == 'tour'?true:null"
																				tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 34 : 35)}}"  
																				attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 34 : 35)}}"
																				style="width:40px!important"
																					class="inner-select-top w-50 mr-1" (change)="calculateNetAmount(i)"
																					formControlName="client_sc2_taxable">
																					<option *ngIf="isTenantIndian" value="T">T</option>
																					<option value="N">N</option>
																				</select>
																		</div>

																		<div class="align-items-center mr-2">
																			<label class="mb-0" title="">Type:</label>

																			<select 
																			[attr.disabled]="miscInvoiceService.invoiceForm.value.sub_invoice_type == 'tour'?true:null"
																			tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 35 : 36)}}"  
																			attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 35 : 36)}}"
																			style="width:40px!important"
																				class="inner-select-top w-50 mr-1" (change)="calculateNetAmount(i)"
																				formControlName="client_sc2_type">
																				<option value="B">B</option>
																				<!-- <option value="N">N</option> -->
																			</select>
																			</div>
																			<div style="width:24%" class="align-items-center mr-2">
																				<label class="mb-0" title="">AMT:</label>
	
																			<input 
																			[attr.disabled]="miscInvoiceService.invoiceForm.value.sub_invoice_type == 'tour'?true:null"
																			tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 36 : 37)}}"  
																			attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 36 : 37)}}"
																			formControlName="client_sc2_amount"
																				(input)="calculateNetAmount(i)"
																				class="traveller-input-field  text-right w-100" type="text" />
																		</div>
																		<ng-container *ngIf="isTenantIndian">
																			<div style="width:24%" class="align-items-center mr-2">
																				<label class="mb-0" title="">GST On:</label>
																				<select class="inner-select-top w-100"
																				[attr.disabled]="miscInvoiceService.invoiceForm.value.sub_invoice_type == 'tour'?true:null"
																				tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 37 : 38)}}"  
																				attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 37 : 38)}}"
																					(change)="calculateNetAmount(i)" formControlName="client_gst_type_2">
																					<option disabled title= 'S'value="S">SC1</option>
																					<option  title= 'B' value="B">B</option>
																					<option disabled title= 'TOTAL' value="TOTAL">TOTAL</option>
																				</select>
																			</div>

																			<div style="width:24%" class="align-items-center mr-2">
																				<label class="mb-0">GST Rate:</label>
																				<select 
																				[attr.disabled]="miscInvoiceService.invoiceForm.value.sub_invoice_type == 'tour'?true:null"
																					class="traveller-input-field" [attr.disabled]="travellers.value.client_sc2_taxable == 'T'?true:null"
																					tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 38 : 39)}}"  
																					attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 38 : 39)}}"
																					type="number" formControlName="client_gst_conf_2"
																					(change)="calculateNetAmount(i)" >
																					<option value= 0 >0</option>
																					<option value= 5 >5</option>
																					<option value=12 >12</option>
																					<option value=18 >18</option>
																					<option value=28 >28</option>
																				</select>
																			
																			</div>

																			<div style="width:24%" class="align-items-center mr-2">
																				<label class="mb-0">CGST</label>
																				<input disabled formControlName="client_cgst_2" class="traveller-input-field"
																					type="number" />
																			</div>

																			<div style="width:24%" class="align-items-center mr-2">
																				<label class="mb-0 ml-1 mr-1">SGST</label>
																				<input disabled formControlName="client_sgst_2" class="traveller-input-field"
																					type="number" />
																			</div>

																			<div style="width:24%" class="align-items-center">
																				<label class="mb-0">IGST</label>
																				<input disabled formControlName="client_igst_2" class="traveller-input-field"
																					type="number" />
																			</div>
																		</ng-container>
																		</div>
																	</td>
																	<td>
																		<div class="d-flex justify-content-between">
																			<!-- <div class="align-items-center mr-2">
																				<label class="mb-0" title="">Taxable:</label>
																				<select 
																				tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'?39 : 40)}}"  
																				attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 39 : 40)}}"
																				style="width:40px!important"
																					class="inner-select-top w-50 mr-1"  (change)="calculateNetAmount(i)"
																					formControlName="supplier_sc2_taxable">
																					<option value="T">T</option>
																					<option value="N">N</option>
																				</select>
																			</div> -->
																			<div class="align-items-center mr-2">
																				<label class="mb-0" title="">Type:</label>
																			<select 
																			tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 40 : 41)}}"  
																			attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 40 : 41)}}"
																			style="width:40px!important"
																				class="inner-select-top w-50 mr-1" (change)="calculateNetAmount(i)"
																				formControlName="supplier_sc2_type">
																				<option value="B">B</option>
																			</select>
																		</div>
																		<div style="width:24%" class="align-items-center mr-2">
																			<label class="mb-0" title="">AMT:</label>
																			<input 
																			tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 41 : 42)}}"  
																			attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 41 : 42)}}" 
																			formControlName="supplier_sc2_amount"
																				(input)="calculateNetAmount(i)"
																				class="traveller-input-field  text-right w-100" type="text" />
																		</div>
																		<ng-container *ngIf="isTenantIndian">
																			<div style="width:24%" class="align-items-center mr-2">
																				<label class="mb-0" title="">GST On:</label>
																				<select 
																				tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 42 : 43)}}"  
																				attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 42 : 43)}}"
																				class="inner-select-top w-100" 
																					(change)="calculateNetAmount(i)" formControlName="supplier_gst_type_2">
																					<option disabled title= 'S' value="S">SC1</option>
																					<option title= 'B' value="B">B</option>
																					<option disabled title= 'T' value="T">OT</option>
																				</select>
																			</div>

																			<div style="width:24%" class="align-items-center mr-2">
																				<label class="mb-0">GST Rate:</label>
																				<select 
																					class="traveller-input-field" [attr.disabled]="travellers.value.supplier_sc2_taxable == 'T'?true:null"
																					tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 43 : 44)}}"  
																					attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 43 : 44)}}"
																					type="number" formControlName="supplier_gst_conf_2"
																					(change)="calculateNetAmount(i)" >
																					<option value= 0 >0</option>
																					<option value= 5 >5</option>
																					<option value=12 >12</option>
																					<option value=18 >18</option>
																					<option value=28 >28</option>
																				</select>
																			
																			</div>

																			<div style="width:24%" class="align-items-center mr-2">
																				<label class="mb-0">CGST</label>
																				<input disabled formControlName="supplier_cgst_2" class="traveller-input-field"
																					type="number" />
																			</div>

																			<div style="width:24%" class="align-items-center mr-2">
																				<label class="mb-0 ml-1 mr-1">SGST</label>
																				<input disabled formControlName="supplier_sgst_2" class="traveller-input-field"
																					type="number" />
																			</div>

																			<div style="width:24%" class="align-items-center">
																				<label class="mb-0">IGST</label>
																				<input disabled formControlName="supplier_igst_2" class="traveller-input-field"
																					type="number" />
																			</div>
																		</ng-container>
																	</div>
																	</td>
																</tr>
																<!-- service charge 3 -->
																<tr>
																	<td class="text-right">
																		<div class="align-items-center mr-2">

																			<label class="mb-0" title="">Service Charge 3</label>
																			<ng-container *ngIf="isTenantIndian">
																			<div class="d-flex justify-content-between" >

																				<div >hsn</div>
																				<input [ngClass]="((travellers.value.client_cgst_3!=0 || travellers.value.client_sgst_3!=0 || travellers.value.client_igst_3!=0 || (travellers.value.client_sc3_taxable=='T' && travellers.value.client_sc3_amount!=0)) && (!travellers.value.hsn_3)&&(isGstNumberExist==true))?'validateError':''"
																				class="traveller-input-field  text-right w-50" type="text" formControlName="hsn_3" oninput="this.value = this.value.toUpperCase()" />
																			</div>
																			</ng-container>

																	</div>
																</td>
																	<td>
																		<div class="d-flex justify-content-between">
																			<div class="align-items-center mr-2">
																				<label class="mb-0" title="">Taxable:</label>
																			<select
																			[attr.disabled]="miscInvoiceService.invoiceForm.value.sub_invoice_type == 'tour'?true:null"
																			tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 44 : 45)}}"  
																			attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 44 : 45)}}"
																			style="width:40px!important"
																				class="inner-select-top w-50 mr-1" (change)="calculateNetAmount(i)"
																				formControlName="client_sc3_taxable">
																				<option *ngIf="isTenantIndian" value="T">T</option>
																				<option value="N">N</option>
																			</select>
																		</div>
																		<div class="align-items-center mr-2">
																			<label class="mb-0" title="">Type:</label>
																			<select
																			[attr.disabled]="miscInvoiceService.invoiceForm.value.sub_invoice_type == 'tour'?true:null"
																			tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 45 :46)}}"  
																			attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 45 :46)}}"
																			style="width:40px!important"
																				class="inner-select-top w-50 mr-1" (change)="calculateNetAmount(i)"
																				formControlName="client_sc3_type">
																				<option value="OT">OT</option>
																			</select>
																		</div>

																		<div style="width:24%" class="align-items-center mr-2">
																			<label class="mb-0" title="">AMT:</label>
																			<input 
																			[attr.disabled]="miscInvoiceService.invoiceForm.value.sub_invoice_type == 'tour'?true:null"
																			tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 46 : 47)}}"  
																			attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 46 : 47)}}" 
																			formControlName="client_sc3_amount"
																				(input)="calculateNetAmount(i)"
																				class="traveller-input-field  text-right w-100" type="text" />
																		</div>
																		<ng-container *ngIf="isTenantIndian">
																			<div style="width:24%" class="align-items-center mr-2">
																				<label class="mb-0" title="">GST On:</label>
																				<select 
																				[attr.disabled]="miscInvoiceService.invoiceForm.value.sub_invoice_type == 'tour'?true:null"
																				class="inner-select-top w-100" 
																					tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 47 : 48)}}"  
																					attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 47 : 48)}}"
																					(change)="calculateNetAmount(i)" formControlName="client_gst_type_3">
																					<option disabled title= 'S' value="S">SC1</option>
																					<option disabled title= 'B' value="B">B</option>
																					<option  title= 'TOTAL' value="TOTAL">TOTAL</option>
																				</select>
																			</div>

																			<div style="width:24%" class="align-items-center mr-2">
																				<label class="mb-0">GST Rate:</label>
																				<select 
																				[attr.disabled]="miscInvoiceService.invoiceForm.value.sub_invoice_type == 'tour'?true:null"
																					class="traveller-input-field" [attr.disabled]="travellers.value.client_sc3_taxable == 'T'?true:null"
																					tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'?48 : 49)}}"  
																					attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 48 : 49)}}"
																					type="number" formControlName="client_gst_conf_3"
																					(change)="calculateNetAmount(i)" >
																					<option value= 0 >0</option>
																					<option value= 5 >5</option>
																					<option value=12 >12</option>
																					<option value=18 >18</option>
																					<option value=28 >28</option>
																				</select>
																			
																			</div>

																			<div style="width:24%" class="align-items-center mr-2">
																				<label class="mb-0">CGST</label>
																				<input disabled formControlName="client_cgst_3" class="traveller-input-field"
																					type="number" />
																			</div>

																			<div style="width:24%" class="align-items-center mr-2">
																				<label class="mb-0 ml-1 mr-1">SGST</label>
																				<input disabled formControlName="client_sgst_3" class="traveller-input-field"
																					type="number" />
																			</div>

																			<div style="width:24%" class="align-items-center">
																				<label class="mb-0">IGST</label>
																				<input disabled formControlName="client_igst_3" class="traveller-input-field"
																					type="number" />
																			</div>
																		</ng-container>
																	</div>
																	</td>
																	<td>
																		<div class="d-flex justify-content-between">
																			<!-- <div class="align-items-center mr-2">
																				<label class="mb-0" title="">Taxable:</label>
																				<select 
																				tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 49 : 50)}}"  
																				attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 49 : 50)}}"
																				style="width:40px!important" 
																					class="inner-select-top w-50 mr-1" (change)="calculateNetAmount(i)"
																					formControlName="supplier_sc3_taxable">
																					<option value="T">T</option>
																					<option value="N">N</option>
																				</select>
																			</div> -->

																			<div class="align-items-center mr-2">
																				<label class="mb-0" title="">Type:</label>
																			<select 
																			tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 50 : 51)}}"  
																			attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 50 : 51)}}"
																			style="width:40px!important"
																				class="inner-select-top w-50 mr-1" (change)="calculateNetAmount(i)"
																				formControlName="supplier_sc3_type">
																				<option value="OT">OT</option>
																			</select>
																			</div>
																			<div style="width:24%" class="align-items-center mr-2">
																				<label class="mb-0" title="">AMT:</label>
																			<input 
																			tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 51 : 52)}}"  
																			attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 51 : 52)}}" 
																			formControlName="supplier_sc3_amount"
																				(input)="calculateNetAmount(i)"
																				class="traveller-input-field  text-right w-100" type="text" />
																		</div>
																		<ng-container *ngIf="isTenantIndian">
																			<div style="width:24%" class="align-items-center mr-2">
																				<label class="mb-0" title="">GST On:</label>
																				<select 
																				class="inner-select-top w-100" 
																					tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 52 : 53)}}"  
																					attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 52 : 53)}}"
																					(change)="calculateNetAmount(i)" formControlName="supplier_gst_type_3">
																					<option disabled title= 'S' value="S">SC1</option>
																					<option disabled title= 'B' value="B">B</option>
																					<option title= 'TOTAL'value="TOTAL">TOTAL</option>
																				</select>
																			</div>

																			<div style="width:24%"   class="align-items-center mr-2">
																				<label class="mb-0">GST Rate:</label>
																				<select [attr.disabled]="travellers.value.supplier_sc3_taxable == 'T'?true:null"
																					tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 53 : 54)}}"  
																					attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 53 : 54)}}"
																					class="traveller-input-field" 
																					type="number" formControlName="supplier_gst_conf_3"
																					(change)="calculateNetAmount(i)" >
																					<option value= 0 >0</option>
																					<option value= 5 >5</option>
																					<option value=12 >12</option>
																					<option value=18 >18</option>
																					<option value=28 >28</option>
																				</select>
																			</div>

																			<div style="width:24%" class="align-items-center mr-2">
																				<label class="mb-0">CGST</label>
																				<input disabled formControlName="supplier_cgst_3" class="traveller-input-field"
																					type="number" />
																			</div>

																			<div style="width:24%" class="align-items-center mr-2">
																				<label class="mb-0 ml-1 mr-1">SGST</label>
																				<input disabled formControlName="supplier_sgst_3" class="traveller-input-field"
																					type="number" />
																			</div>

																			<div style="width:24%" class="align-items-center">
																				<label class="mb-0">IGST</label>
																				<input disabled formControlName="supplier_igst_3" class="traveller-input-field"
																					type="number" />
																			</div>
																		</ng-container>
																	</div>
																	</td>
																</tr>

																<tr *ngIf="miscInvoiceService.invoiceForm.value.transaction_method == 'purchase'">
																	<td class="text-right">
																		XXL Charges.
																	</td>
																	<td>
																		<input 
																		tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 54 : 55)}}"  
																		attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 54 : 55)}}"
																		formControlName="client_xxl_charges"
																		(input)="replicateClientXXLL=='true'?replicateClientAmount(i,'client_xxl_charges','supplier_xxl_charges'):calculateNetAmount(i)"
																		class="traveller-input-field  text-right" type="text" />
																	</td>
																	<td>
																		<input 
																		tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 55 : 56)}}"  
																		attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 55 : 56)}}"
																		formControlName="supplier_xxl_charges"
																		(input)="calculateNetAmount(i)" class="traveller-input-field  text-right"
																		type="text" />
																	</td>
																</tr>

																<tr *ngIf="miscInvoiceService.invoiceForm.value.transaction_method == 'purchase'">
																	<td class="text-right">
																		RAF Charges.
																	</td>

																	<td>
																		<div class="d-flex justify-content-between">
																			<div style="width:24%" class="align-items-center mr-2">
																				<label class="mb-0" title="">Amount</label>
																				<input 
																					tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 56 : 57)}}"  
																					attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 56 : 57)}}"
																					formControlName="client_raf_charges" (change)="changeAmount('client_raf_charges',i)"
																					class="traveller-input-field  text-right" type="text" 
																				/>
																			</div>

																			<ng-container *ngIf="isTenantIndian">
																				<div style="width:24%" class="align-items-center mr-2">
																					<label class="mb-0">CGST</label>
																					<input disabled formControlName="client_cgst_on_raf" class="traveller-input-field" />
																				</div>
																				<div style="width:24%" class="align-items-center mr-2">
																					<label class="mb-0 ml-1 mr-1">SGST</label>
																					<input disabled formControlName="client_sgst_on_raf" class="traveller-input-field"
	/>
																				</div>
																				<div style="width:24%" class="align-items-center">
																					<label class="mb-0">IGST</label>
																					<input disabled formControlName="client_igst_on_raf" class="traveller-input-field" />
																				</div>
																			</ng-container>

																			<ng-container *ngIf="!isTenantIndian">
																				<div style="width:24%" class="align-items-center mr-2">
																					<label class="mb-0">{{vatAlternetname}}</label>
																					<input disabled formControlName="client_vat_on_raf" class="traveller-input-field" />
																				</div>
																			</ng-container>
																			
																		</div>
																	</td>

																	<td>
																		<div class="d-flex justify-content-between">
																			<div style="width:24%" class="align-items-center mr-2">
																				<label class="mb-0" title="">Amount</label>
																				<input 
																					tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 57 : 58)}}"  
																					attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 57 : 58)}}"
																					formControlName="supplier_raf_charges" (change)="changeAmount('supplier_raf_charges',i)"
																					class="traveller-input-field  text-right" type="text" 
																				/>
																			</div>

																			<ng-container *ngIf="isTenantIndian">
																				<div style="width:24%" class="align-items-center mr-2">
																					<label class="mb-0">CGST</label>
																					<input disabled formControlName="supplier_cgst_on_raf" class="traveller-input-field" />
																				</div>
																				<div style="width:24%" class="align-items-center mr-2">
																					<label class="mb-0 ml-1 mr-1">SGST</label>
																					<input disabled formControlName="supplier_sgst_on_raf" class="traveller-input-field"
	/>
																				</div>
																				<div style="width:24%" class="align-items-center">
																					<label class="mb-0">IGST</label>
																					<input disabled formControlName="supplier_igst_on_raf" class="traveller-input-field" />
																				</div>
																			</ng-container>

																			<ng-container *ngIf="!isTenantIndian">
																				<div style="width:24%" class="align-items-center mr-2">
																					<label class="mb-0">{{vatAlternetname}}</label>
																					<input disabled formControlName="supplier_vat_on_raf" class="traveller-input-field" />
																				</div>
																			</ng-container>

																		</div>
																	</td>
																</tr>
									
																<tr>
																	<td class="text-right">
																		Net Amount
																	</td>
																	<td>
																		<input formControlName="client_net_amount" readonly
																			class="traveller-input-field  text-right" type="text" />
																	</td>
																	<td>
																		<input formControlName="supplier_net_amount" readonly
																			class="traveller-input-field  text-right" type="text" />
																	</td>
																</tr>
									
															</tbody>
														</table>
													</td>
												</tr>
												<tr>
													<td colspan="4"></td>
													<td colspan="9">
														<div class="d-flex justify-content-center align-items-center mt-3">
															
															<button 
															tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 58 : 59)}}"  
															attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(travellers.value.pay_type != 'OUR_CC'? 58 : 59)}}"
															type="button" 
															class="btn-style mb-2 mr-2"
															(click)="openReplicateModal(showTravellerIndex)"
															>
																Next Service
															</button>
				
															<button 
															tabIndex="{{i*totalInputInTravellers+staticInputCount+(showTravellerIndex < DynamicFormControls.controls.length - 1 ? 59 : 60)}}"  
															attr.tabIndex="{{i*totalInputInTravellers+staticInputCount+(showTravellerIndex < DynamicFormControls.controls.length - 1 ? 59 : 60)}}"
															type="button" 
															class="btn-style bg-green mb-2" 
															(click)="openReplicateModal(i)">
																Save & Return To Summary
															</button>
														</div>
													</td>
													
												</tr>
											</ng-container>
			
										</ng-container>
									</ng-container>
								</tbody>
							</table>
						</div>
			
			
					</div>
				</div>
			
			</form>
			
			<button type="button" hidden #openModal data-toggle="modal" data-target="#replicateConfirm"></button>

			<!-- Modal -->
			<div id="replicateConfirm" class="modal fade" role="dialog" data-backdrop="false">
				<div class="modal-dialog">

					<!-- Modal content-->
					<div class="modal-content">
						<div class="modal-header">
							<h4 class="modal-title">Confirmation</h4>
							<button type="button" class="close" data-dismiss="modal">&times;</button>
						</div>
						<div class="modal-body">
							<p>Do you want to add another service?</p>
						</div>
						<div class="modal-footer">
							<button 
								tabIndex="{{miscInvoiceService.lastIndexOfTraveller +7}}"  
								attr.tabIndex="{{miscInvoiceService.lastIndexOfTraveller +7}}"
								type="button" 
								class="btn-style" 
 								 (click)="replicateFormData(showTravellerIndex);" 								data-dismiss="modal">
								yes
							</button>
							<button 
								tabIndex="{{miscInvoiceService.lastIndexOfTraveller +8}}"  
								attr.tabIndex="{{miscInvoiceService.lastIndexOfTraveller +8}}"
								type="button" 
								class="btn-style"  
								(click)="returnToInvoice()" 
								data-dismiss="modal">
								No
							</button>
						</div>
					</div>

				</div>
			</div>

			<app-misc-invoice-fare-summary [miscInvoiceService]="miscInvoiceService"></app-misc-invoice-fare-summary>
       </div>
	   <div class="custom-table mt-3">

		<div class="table-actions d-flex justify-content-between">
			<div class="action d-flex flex-column">
				<span *ngIf="miscInvoiceService.invoiceForm.controls.narration_1.value">
				   <span class="text-grey">Narration 1 :</span> {{miscInvoiceService.invoiceForm.controls.narration_1.value}}
				</span>
				<span *ngIf="miscInvoiceService.invoiceForm.controls.narration_2.value">
					<span class="text-grey">Narration 2 :</span> {{miscInvoiceService.invoiceForm.controls.narration_2.value}}
				</span>
				<span *ngIf="miscInvoiceService.invoiceForm.controls.narration_3.value">
					<span class="text-grey">Narration 3 :</span> {{miscInvoiceService.invoiceForm.controls.narration_3.value}}
				</span>
				<span *ngIf="miscInvoiceService.invoiceForm.controls.narration_4.value">
					<span class="text-grey">Narration 4 :</span>  {{miscInvoiceService.invoiceForm.controls.narration_4.value}}
				</span>
			</div>

			<div class="subtotal">
				<div class="total-box">
					<span class="title-type">Total Client Amount</span>
					<span class="result-type" *ngIf="miscInvoiceService.totalFareModel && miscInvoiceService.totalFareModel.length > 0 && miscInvoiceService.totalFareModel[0].client_net_amount">
						{{(miscInvoiceService.totalFareModel[0].client_net_amount?miscInvoiceService.totalFareModel[0].client_net_amount:0) | currency: currencyCode :'symbol': '1.0-0' : nativeLanguageCode}}
					</span>
				</div>

				<div *ngIf="isTenantIndian">
					<div class="total-box ">
						<div class="w-100 d-flex justify-content-between">
							<div>
								<span class="mb-0 title-type">TCS Rate</span>
							</div>
							<div>
								<input class="traveller-input-field text-right" type="number" formControlName="tcs_rate" (input)="miscInvoiceService.calculateFromApi(0)" />
							</div>
							
						</div>
					
					</div>
					<div class="total-box">
						<div class="w-100 d-flex justify-content-between">
							<div>
								<span class="mb-0 title-type">Amount</span>
							</div>
							<div>
								<input formControlName="tcs_amount" readonly class="traveller-input-field  text-right" type="text" disabled/>
							</div>
						</div>
			     	</div>
			    </div>

				<div class="total-box text-danger ">
					<span class="title-type">Grand Total</span>
					<span class="result-type" *ngIf="miscInvoiceService.totalFareModel && miscInvoiceService.totalFareModel.length > 0 && 
						miscInvoiceService.totalFareModel[0].client_net_amount" >
						{{(miscInvoiceService.totalFareModel[0].client_net_amount + miscInvoiceService.invoiceForm.value.tcs_amount)  | currency: currencyCode :'symbol': '1.0-0' : nativeLanguageCode}}
					</span>
				</div>
				
				<div class="currencyWrapper mt-5" *ngIf="!isTenantIndian">
					<div class="row">
						<div class="col-4 input-fiel ">
							<select id="flightType" formControlName="sales_currency"  class="input-ui inv-date-input"  >
								<option value="">Select</option>
								<option value="AED">AED</option>
								<option value="CAD">CAD</option>
								<option value="USD">USD</option>
								<option value="INR">INR</option>
								<option value="EURO">EURO</option>
								<option value="POUND">POUND</option>
							</select>
							<label for="sales_currency">Sales Curr.</label>
						</div>

						<div class="col-4  input-fiel p-0">
							<input class="input-ui inv-number-input" formControlName="sales_currency_rate" id="currency_rate"
								type="text" (input)="changeSalesCurrencyAmount($event)"
							/>
							<label for="sales_currency_rate">Sales Curr. Rate</label>
						</div>

						<div class="col-4 input-fiel ">
							<input  class="input-ui inv-number-input" id="sales_currency_amount" formControlName="sales_currency_amount"
								 type="text" disabled
							/>
							<label for="sales_currency_amount">Sales Amount</label>
						</div>
					</div>
				   
				</div>
				<div *ngIf="salesCurrencyPrint=='true'"  class="currencyWrapper mt-5">
					<div class="row" style="justify-content: flex-end">
						<div class="col-4 input-fiel ">
							<select id="flightType" class="input-ui inv-date-input" formControlName="sales_currency" >
								<option value="">Select</option>
								<option value="AED">AED</option>
								<option value="USD">USD</option>
								<option value="INR">INR</option>
								<option value="EURO">EURO</option>
								<option value="POUND">POUND</option>
							</select>
							<label for="sales_currency">Sales Curr.</label>
						</div>

						<div class="col-4  input-fiel p-0">
							<input oninput="this.value = this.value"  class="input-ui inv-number-input text-right" id="sales_currency_rate"
								formControlName="sales_currency_rate" type="text" 
							/>
							<label for="sales_currency_rate">Sales Curr. Rate</label>
						</div>
					</div>
				   
				</div>
			</div>
		</div>
		
		<div class="text-input-group d-flex justify-content-between mt-3">
			<!-- <div class="input-fiel mt-10 w-50">
				<input tabIndex="{{sectorService.lastIndexOfTraveller+3}}"
					attr.tabIndex="{{sectorService.lastIndexOfTraveller+3}}"
					oninput="this.value = this.value.toUpperCase()" class="input-ui w-100" id="narration"
					formControlName="narration_4" type="text" placeholder="Narration" /><label
					for="narration">Narration 4</label>
			</div> -->
			<div class="input-fiel mt-10 w-50  mr-3">
				<input tabIndex="{{miscInvoiceService.lastIndexOfTraveller+3}}"
					attr.tabIndex="{{miscInvoiceService.lastIndexOfTraveller+3}}"
					oninput="this.value = this.value.toUpperCase()" class="input-ui w-100" id="narration"
					formControlName="narration_5" type="text" placeholder="Narration" /><label
					for="narration" [ngClass]="{'error-label-narration': !miscInvoiceService.invoiceForm.controls.narration_5.valid && miscInvoiceService.invoiceForm.controls.narration_5.hasError('pattern')}">Narration 5</label>
				<span class="error-ui"
								*ngIf="!miscInvoiceService.invoiceForm.controls.narration_5.valid && miscInvoiceService.invoiceForm.controls.narration_5.hasError('pattern')">
								Invalid special chars</span>
			</div>
			<div class="input-fiel mr-0 w-50 mt-10">
				<input tabIndex="{{miscInvoiceService.lastIndexOfTraveller+4}}"
					attr.tabIndex="{{miscInvoiceService.lastIndexOfTraveller+4}}"
					oninput="this.value = this.value.toUpperCase()" class="input-ui w-100" id="remark"
					formControlName="remark" type="text" placeholder="Remark" /><label for="remark">Remark</label>
			</div>
		</div>

		</div>
	</div>
</div>

<div  *ngIf="(!invoiceData) || invoiceData.is_consolidate!=true" class="btn-field bottom-btns-container full-width-btn-container  d-flex align-item-center justify-content-end ml-0 mr-0">   
	
	<ng-container *ngIf="invoiceMode != 'view'">
		<div class="w-100 d-flex align-item-center">
 
			<div class="d-flex align-items-center flex-row" *ngIf="showRefundableCheckbox == true && miscInvoiceService.invoiceForm.value.transaction_method == 'purchase' ">
				<label for="clientRefundable" style="font-size: 12px!important;font-weight: 400;color: #000!important;" class="mb-0">Non Refundable</label>
				<input class="ml-10" formControlName="nonRefundable" id="clientRefundable" type="checkbox" style="height: 14px;"/>
			</div>

			<div class="d-flex align-items-center flex-row ml-auto">
				<div class="d-flex align-items-center flex-row  mr-20" *ngIf="billOfSupplyActive === true">
					<label for="clientBos" class="mb-0 clientRefLbl">Bill Of Supply</label>
					<input class="ml-10" formControlName="bill_of_supply" id="clientBos" type="checkbox" style="height: 14px;"/>
				</div>

				<button 
				type="button" class="btn-style mr-3 bg-blue"
					(click)="saveDraftInvoice()" id="save_mis_invoice_btn">
					Save as Draft
				</button>
				
				<button type="button" (click)="closeMaxModule()" class="btn-style bg-green mr-3">
					Reset
				</button> 

				<button 
				tabIndex="{{miscInvoiceService.lastIndexOfTraveller +6}}"  
				attr.tabIndex="{{miscInvoiceService.lastIndexOfTraveller +6}}"
				type="button" class="btn-style bg-purple"
					(click)="saveProductInvoice()" id="save_mis_invoice_btn">
					Save
				</button>
				<span style="position: relative; display: inline-block;" >
					<div class="d-flex align-items-center flex-row" style="margin-left: 14px;">
						<button (click)="toggleMenu()" class="hamburger-menu">
							&#9776; <!-- Hamburger icon -->
						</button>
					</div>
					
					<span class="rcm-invoice-btn" *ngIf="menuVisible">
						<div class="rcm-item d-flex align-item-center">
							<input  formControlName="rcm_applicable" id="rcm_applicable" type="checkbox"  />
							<label for="rcm_applicable" class="mb-0 ml-10 clientRefLbl">RCM Applicable</label>
						</div>
						<div class="rcm-item d-flex align-item-center">
							<input formControlName="reverse_tds" id="reverse_tds" type="checkbox"  />
							<label for="reverse_tds" class="mb-0 ml-10 clientRefLbl">Reverse TDS</label>
						</div>
						<div class="rcm-item">
                                    <label class="mb-0 ml-10 clientRefLbl"(click)="openAccountPage()">Client Adj. View</label>
						</div>
						<ng-container *ngFor="let supplierName of uniqueSupplier | keyvalue">
							<!-- supplierName.key = the supplier name (string) -->
							<!-- supplierName.value = array of objects with code and name -->

							<div *ngFor="let sup of supplierName.value" class="rcm-item">
								<label class="mb-0 ml-10 clientRefLbl" (click)="openSupplierPage(sup.code)">
								{{ sup.name }} Adj. View
								</label>
							</div>
						</ng-container>
						<div class="rcm-item">
						<label class="mb-0 ml-10 clientRefLbl" (click)="openKnockOffPage()">Knock Off Client</label>
						</div>
						<ng-container *ngFor="let supplierName of uniqueSupplier | keyvalue">
							<!-- supplierName.key = the supplier name (string) -->
							<!-- supplierName.value = array of objects with code and name -->

						<div *ngFor="let sup of supplierName.value" class="rcm-item">
							<label class="mb-0 ml-10 clientRefLbl" (click)="openSupplierKnockOffPage(sup.code)">
							{{ sup.name }} Knock Off
							</label>
						</div>
						</ng-container>
					</span>
				</span>
			</div>
			
		</div>		
	</ng-container>

	<ng-container *ngIf="invoiceMode == 'view'">
		
		<div class="w-100 d-flex align-item-center">
			<div class="d-flex align-items-center flex-row" *ngIf="showRefundableCheckbox == true && miscInvoiceService.invoiceForm.value.transaction_method == 'purchase' ">
				<label for="clientRefundable" style="font-size: 12px!important;font-weight: 400;color: #000!important;" class="mb-0">Non Refundable</label>
				<input class="ml-10" disabled formControlName="nonRefundable" id="clientRefundable" type="checkbox" style="height: 14px;"/>
			</div>

			
			
			<div class="ml-auto row justify-content-between">

<!-- <ng-container *ngIf="associateTransactionOnHQ==false"> -->
				<button 
				tabIndex="{{miscInvoiceService.lastIndexOfTraveller +6}}"  
				attr.tabIndex="{{miscInvoiceService.lastIndexOfTraveller +6}}"
				type="button" class="btn-style bg-cyan mr-3"
					(click)="openUpdateConfirmModal()" id="update_mis_invoice_btn">
					{{invoiceData && invoiceData.status == 'Draft' ? 'Save' : 'Modify' }}
				</button>
				<!-- </ng-container> -->
				<ng-container *ngIf="associateTransaction==false">

				
				<button 
				tabIndex="{{miscInvoiceService.lastIndexOfTraveller +7}}"  
				attr.tabIndex="{{miscInvoiceService.lastIndexOfTraveller +7}}"
				type="button" class="btn-style bg-red mr-3"
					(click)="openDeleteConfirmModal()" id="delete_mis_invoice_btn">
					Delete
				</button>
				</ng-container>

				<ng-container *ngIf="invoiceData && invoiceData.status != 'Draft'">
				<span style="position: relative; display: inline-block;">
				<button type="button" class="btn-style bg-denim  mr-3" (click)="clickToPrintOptions()">
					Print
				</button>
				<span class="form-invoice-btn"  *ngIf="showPrintOptions">
						<button type="button" *ngIf="checkEInvoice==false || isTesoyBoult==false"
						(click)="openVoucher(invoice_no)" class="btn-style bg-denim mr-2">Invoice</button>
			
						<button type="button" *ngIf="isTenantIndian"
						(click)="checkWhetherEInvGeneratedOrNot(invoice_no)" class="btn-style bg-denim " >E-Invoice</button>
					</span>
				</span>

				<button type="button" class="btn-style bg-pine mr-3" *ngIf="invoiceData && invoiceData.bos_reference" 
					(click)="openBosReference()" id="open_bos_btn">
					{{invoiceData.bill_of_supply ? 'TAX INVOICE' : 'BILL OF SUPPLY'}}
				</button>
				
				<button type="button" class="btn-style bg-brown mr-3" (click)="viewJournal(invoice_no)" id="journal_ms_invoice_btn">
					Journal
				</button>
				<button type="button" *ngIf="salesCurrencyPrint=='true'"
                 (click)="openBill(invoice_no)" class="btn-style bg-denim mr-3" id="activity_invoice_log_btn">MultiCurrency Bill
            </button>
				<button type="button" class="btn-style bg-indigo mr-3" (click)="openActivity(invoice_no)">
					Activity 
				</button>
				<button type="button" class="btn-style bg-rusty-red text-white"
				tabIndex="{{miscInvoiceService.lastIndexOfTraveller+8}}" attr.tabIndex="{{miscInvoiceService.lastIndexOfTraveller+8}}" 
				(click)="openSendEmailModal()" id="invoice_send_mail_btn" id="mis_invoice_send_mail_btn">Email</button>
				<span style="position: relative; display: inline-block;" >
					<div class="d-flex align-items-center flex-row" style="margin-left: 14px;">
						<button (click)="toggleMenu()" class="hamburger-menu">
							&#9776; <!-- Hamburger icon -->
						</button>
					</div>
					
					<span class="rcm-invoice-btn" *ngIf="menuVisible">
						<div class="rcm-item d-flex align-item-center">
							<input  formControlName="rcm_applicable" id="rcm_applicable" type="checkbox"  />
							<label for="rcm_applicable" class="mb-0 ml-10 clientRefLbl">RCM Applicable</label>
						</div>
						<div class="rcm-item d-flex align-item-center">
							<input formControlName="reverse_tds" id="reverse_tds" type="checkbox"  />
							<label for="reverse_tds" class="mb-0 ml-10 clientRefLbl">Reverse TDS</label>
						</div>
						<div class="rcm-item">
                                    <label class="mb-0 ml-10 clientRefLbl"(click)="openAccountPage()">Client Adj. View</label>
						</div>
						<ng-container *ngFor="let supplierName of uniqueSupplier | keyvalue">
							<!-- supplierName.key = the supplier name (string) -->
							<!-- supplierName.value = array of objects with code and name -->
						<div *ngFor="let sup of supplierName.value" class="rcm-item">
							<label class="mb-0 ml-10 clientRefLbl" (click)="openSupplierPage(sup.code)">
							{{ sup.name }} Adj. View
							</label>
						</div>
						</ng-container>
						<div class="rcm-item">
						<label class="mb-0 ml-10 clientRefLbl" (click)="openKnockOffPage()">Knock Off Client</label>
						</div>
						<ng-container *ngFor="let supplierName of uniqueSupplier | keyvalue">
						<!-- supplierName.key = the supplier name (string) -->
						<!-- supplierName.value = array of objects with code and name -->

						<div *ngFor="let sup of supplierName.value" class="rcm-item">
							<label class="mb-0 ml-10 clientRefLbl" (click)="openSupplierKnockOffPage(sup.code)">
							{{ sup.name }} Knock Off
							</label>
						</div>
						</ng-container>
					</span>
				</span>
			</ng-container>
			</div>
		</div>
		<!-- <button type="button"  (click)="viewJournal(invoice_no)" class="btn-style mr-3">Journal</button> -->
	</ng-container>

	
</div>
</form>
<button type="button" hidden #confirmUpdateModal data-toggle="modal" data-target="#updateConfirmationModal"></button>

<div class="modal fade" id="updateConfirmationModal" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true" data-backdrop="false">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4>Confirmation</h4>
                <button type="button" class="close" #closeUpdateModal data-dismiss="modal" aria-label="Close" (click)="resetCurrentOpenedModal()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                Are you sure to <b>update this entry</b> ?
            </div>
            <div class="modal-footer">
                <!-- <button type="button" class="btn-style mr-3"   data-dismiss="modal">No</button> -->
                <button type="button" class="btn-style mr-2" (click)="closeUpdateConfirmModal()">No</button>
                <button type="button" class="btn-style bg-blue" (click)="updateProduct()">Yes</button>
            </div>
        </div>
    </div>
</div>
<button type="button" hidden  #confirmDeleteModal data-toggle="modal" data-target="#deleteConfirmationModal"></button >

    <div class="modal fade" id="deleteConfirmationModal"  role="dialog" aria-labelledby="modelTitleId" aria-hidden="true" data-backdrop="false">
        <div class="modal-dialog modal-md" role="document">
          <div class="modal-content">
            <div class="modal-header">
				<h4>Confirmation</h4>

                <button type="button" class="close" #closeDeleteModal data-dismiss="modal" aria-label="Close" (click)="resetCurrentOpenedModal()">
                  <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                Are you sure to delete this entry ?
            </div>
            <div class="modal-footer">
              <!-- <button type="button" class="btn-style mr-3"   data-dismiss="modal">No</button> -->
              <button type="button" class="btn-style mr-2" (click)="closeDeleteConfirmModal()">No</button>
              <button type="button" class="btn-style bg-red"  (click)="deleteInvoice(invoice_no)" >Yes</button>
            </div>
          </div>
        </div>
      </div>

	  <button
hidden
#openEmailModal
data-target="#emailModalInMiscellaneous"
data-toggle="modal"
></button>
<div
  class="modal"
  id="emailModalInMiscellaneous"
  role="dialog"
  aria-labelledby="emailModalLabel"
  data-backdrop="false"
>
  <div class="modal-dialog" role="document">
	<div class="modal-content">
	  <div class="modal-header">
		<div class="d-flex justify-content-center">
		  <h4 class="modal-title">Send Email</h4>
		</div>
		<button
		  type=" button"
		  class="close"
		  #closeSendEmailModal
		  data-dismiss="modal"
		  aria-label="Close"
		>
		  <span aria-hidden="true">&times;</span>
		</button>
	  </div>
	  <div class="modal-body emailSenders">
		<!-- <div class="d-flex justify-content-end align-item-center">
						  <span *ngIf="!ccEmail" (click)="showCCEmail()" class="text-size-14 mb-0 cursor  mr-2">Cc</span>
						  <span *ngIf="!bccEmail" (click)="showBCCEmail()" class="text-size-14 mb-0 cursor">Bcc</span>
					  </div> -->
		<form [formGroup]="sendEmailForm" style="margin-top: -10px">
		  <div class="form-group text-input-field">
			<textarea
			  class="input-field text-left ng-pristine  ng-valid ng-touched text-size-12"
			  id="toEmail"
			  rows="1"
			  formControlName="toEmails"
			  required
			></textarea>
			<label for="To" class="mb-0">To</label>
		  </div>
		  <div class="d-flex justify-content-end">
			<!-- <label for="To" class="text-size-14 mb-0">To</label> -->
			<div *ngIf="sendEmailForm.controls.toEmails.invalid">
			  <div
				*ngIf="sendEmailForm.controls.toEmails.errors?.required"
				style="color: red"
			  >
				To Email is required.
			  </div>
			</div>
		  </div>

		  <div class="form-group text-input-field mt-0">
			<textarea
			  class="input-field text-left ng-pristine ng-valid ng-touched text-size-12"
			  id="ccEmail"
			  style="max-height: 45px;"
			  formControlName="ccEmails"
			></textarea>
			<label for="Cc" class="mb-0">Cc</label>
		  </div>

		  <div class="form-group text-input-field">
			<textarea
			  class="input-field text-left ng-pristine ng-valid ng-touched text-size-12"
			  id="bccEmail"
			  style="max-height: 45px;"
			  formControlName="bccEmails"
			></textarea>
			<label for="Bcc" class="mb-0">Bcc</label>
		  </div>
		  <div class="text-input-field">
			<input formControlName="subject"  class="input-field text-left text-size-12" type="text" 
			autocomplete="off" />
			<label for="subject">Subject</label>
		</div>
		<div class="form-group text-input-field">
		 <textarea
		   class="input-field text-left ng-pristine ng-valid ng-touched text-size-12"
		   rows="5"
		   formControlName="body"
		 ></textarea>
		 <label for="body" class="mb-0">Mail Body</label>
		 <input type="file" (change)="handleAttachment($event)" />
		</div>
		  <div class="d-flex justify-content-center align-item-center">
			<button type="button" class="btn-style mr-2" data-dismiss="modal">
			  Cancel
			</button>
			<button
			  type="button"
			  class="btn-style bg-green"
			  (click)="callTosendEmail()"
			>
			  Send
			</button>
		  </div>
		</form>
	  </div>
	</div>
  </div>
</div>

<button type="button" hidden #generateEInvoiceModal data-toggle="modal" data-target="#openGenerateEInvoiceModal"></button>

<div class="modal fade" id="openGenerateEInvoiceModal" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true" data-backdrop="false">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4>Confirmation</h4>
                <button type="button" class="close" #closeUpdateModal data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                E-invoice not generated,do you want to generate? 
            </div>
            <div class="modal-footer">
                <button type="button" class="btn-style mr-2" (click)="closeGenerateEInvoiceModal()">No</button>
                <button type="button" class="btn-style bg-red" (click)="generateEInvoice(invoice_no)">Yes</button>
            </div>
        </div>
    </div>
</div>
